import { SavedDeck } from '@/features/player/types';

export const DEFAULT_DECK: SavedDeck = {
  "metadata": {
    "id": "deck-1760676881244-p88pmnr",
      "name": "Krenko",
      "source": "scryfall" as const,
      "cardCount": 100,
      "importedAt": new Date("2025-11-11T12:21:04.411Z"),
      "lastModified": new Date("2025-11-11T12:21:04.411Z")
  },
  "cards": [
    {
      "id": "card-70u5jef7x",
      "cardNumber": 1,
      "name": "Abrade",
      "type_line": "Instant",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/4/c/4c2a1b4e-858c-47a3-be89-9275e48d5475.jpg?1743206610",
          "normal": "https://cards.scryfall.io/normal/front/4/c/4c2a1b4e-858c-47a3-be89-9275e48d5475.jpg?1743206610",
          "large": "https://cards.scryfall.io/large/front/4/c/4c2a1b4e-858c-47a3-be89-9275e48d5475.jpg?1743206610",
          "png": "https://cards.scryfall.io/png/front/4/c/4c2a1b4e-858c-47a3-be89-9275e48d5475.png?1743206610",
          "art_crop": "https://cards.scryfall.io/art_crop/front/4/c/4c2a1b4e-858c-47a3-be89-9275e48d5475.jpg?1743206610",
          "border_crop": "https://cards.scryfall.io/border_crop/front/4/c/4c2a1b4e-858c-47a3-be89-9275e48d5475.jpg?1743206610"
        },
        "back": null
      },
      "scryfallId": "4c2a1b4e-858c-47a3-be89-9275e48d5475",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-s1v3x6v2x",
      "cardNumber": 2,
      "name": "Arcane Signet",
      "type_line": "Artifact",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/3/d/3d994115-378d-4685-a5dc-e448831da434.jpg?1755356098",
          "normal": "https://cards.scryfall.io/normal/front/3/d/3d994115-378d-4685-a5dc-e448831da434.jpg?1755356098",
          "large": "https://cards.scryfall.io/large/front/3/d/3d994115-378d-4685-a5dc-e448831da434.jpg?1755356098",
          "png": "https://cards.scryfall.io/png/front/3/d/3d994115-378d-4685-a5dc-e448831da434.png?1755356098",
          "art_crop": "https://cards.scryfall.io/art_crop/front/3/d/3d994115-378d-4685-a5dc-e448831da434.jpg?1755356098",
          "border_crop": "https://cards.scryfall.io/border_crop/front/3/d/3d994115-378d-4685-a5dc-e448831da434.jpg?1755356098"
        },
        "back": null
      },
      "scryfallId": "3d994115-378d-4685-a5dc-e448831da434",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-oqalwyv8k",
      "cardNumber": 3,
      "name": "Arena of Glory",
      "type_line": "Land",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/d/d/dd148edc-9e43-41aa-bb50-f912115d3e72.jpg?1717047864",
          "normal": "https://cards.scryfall.io/normal/front/d/d/dd148edc-9e43-41aa-bb50-f912115d3e72.jpg?1717047864",
          "large": "https://cards.scryfall.io/large/front/d/d/dd148edc-9e43-41aa-bb50-f912115d3e72.jpg?1717047864",
          "png": "https://cards.scryfall.io/png/front/d/d/dd148edc-9e43-41aa-bb50-f912115d3e72.png?1717047864",
          "art_crop": "https://cards.scryfall.io/art_crop/front/d/d/dd148edc-9e43-41aa-bb50-f912115d3e72.jpg?1717047864",
          "border_crop": "https://cards.scryfall.io/border_crop/front/d/d/dd148edc-9e43-41aa-bb50-f912115d3e72.jpg?1717047864"
        },
        "back": null
      },
      "scryfallId": "dd148edc-9e43-41aa-bb50-f912115d3e72",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-1air0calq",
      "cardNumber": 4,
      "name": "Ashnod's Altar",
      "type_line": "Artifact",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/3/c/3c0f7157-a375-499c-92c7-d47d2e95dbad.jpg?1689999385",
          "normal": "https://cards.scryfall.io/normal/front/3/c/3c0f7157-a375-499c-92c7-d47d2e95dbad.jpg?1689999385",
          "large": "https://cards.scryfall.io/large/front/3/c/3c0f7157-a375-499c-92c7-d47d2e95dbad.jpg?1689999385",
          "png": "https://cards.scryfall.io/png/front/3/c/3c0f7157-a375-499c-92c7-d47d2e95dbad.png?1689999385",
          "art_crop": "https://cards.scryfall.io/art_crop/front/3/c/3c0f7157-a375-499c-92c7-d47d2e95dbad.jpg?1689999385",
          "border_crop": "https://cards.scryfall.io/border_crop/front/3/c/3c0f7157-a375-499c-92c7-d47d2e95dbad.jpg?1689999385"
        },
        "back": null
      },
      "scryfallId": "3c0f7157-a375-499c-92c7-d47d2e95dbad",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-ppbumgngg",
      "cardNumber": 5,
      "name": "Battle Hymn",
      "type_line": "Instant",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/4/3/43b5d46e-7054-44f8-9a14-b412f2f0ab86.jpg?1592709025",
          "normal": "https://cards.scryfall.io/normal/front/4/3/43b5d46e-7054-44f8-9a14-b412f2f0ab86.jpg?1592709025",
          "large": "https://cards.scryfall.io/large/front/4/3/43b5d46e-7054-44f8-9a14-b412f2f0ab86.jpg?1592709025",
          "png": "https://cards.scryfall.io/png/front/4/3/43b5d46e-7054-44f8-9a14-b412f2f0ab86.png?1592709025",
          "art_crop": "https://cards.scryfall.io/art_crop/front/4/3/43b5d46e-7054-44f8-9a14-b412f2f0ab86.jpg?1592709025",
          "border_crop": "https://cards.scryfall.io/border_crop/front/4/3/43b5d46e-7054-44f8-9a14-b412f2f0ab86.jpg?1592709025"
        },
        "back": null
      },
      "scryfallId": "43b5d46e-7054-44f8-9a14-b412f2f0ab86",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-hw5ofx4cs",
      "cardNumber": 6,
      "name": "Blood Moon",
      "type_line": "Enchantment",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/d/0/d072e9ca-aae7-45dc-8025-3ce590bae63f.jpg?1753711840",
          "normal": "https://cards.scryfall.io/normal/front/d/0/d072e9ca-aae7-45dc-8025-3ce590bae63f.jpg?1753711840",
          "large": "https://cards.scryfall.io/large/front/d/0/d072e9ca-aae7-45dc-8025-3ce590bae63f.jpg?1753711840",
          "png": "https://cards.scryfall.io/png/front/d/0/d072e9ca-aae7-45dc-8025-3ce590bae63f.png?1753711840",
          "art_crop": "https://cards.scryfall.io/art_crop/front/d/0/d072e9ca-aae7-45dc-8025-3ce590bae63f.jpg?1753711840",
          "border_crop": "https://cards.scryfall.io/border_crop/front/d/0/d072e9ca-aae7-45dc-8025-3ce590bae63f.jpg?1753711840"
        },
        "back": null
      },
      "scryfallId": "d072e9ca-aae7-45dc-8025-3ce590bae63f",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-kj4n6am1t",
      "cardNumber": 7,
      "name": "Brightstone Ritual",
      "type_line": "Instant",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/5/b/5b08b0a6-c94e-4407-8a24-c8202497b5f2.jpg?1562916460",
          "normal": "https://cards.scryfall.io/normal/front/5/b/5b08b0a6-c94e-4407-8a24-c8202497b5f2.jpg?1562916460",
          "large": "https://cards.scryfall.io/large/front/5/b/5b08b0a6-c94e-4407-8a24-c8202497b5f2.jpg?1562916460",
          "png": "https://cards.scryfall.io/png/front/5/b/5b08b0a6-c94e-4407-8a24-c8202497b5f2.png?1562916460",
          "art_crop": "https://cards.scryfall.io/art_crop/front/5/b/5b08b0a6-c94e-4407-8a24-c8202497b5f2.jpg?1562916460",
          "border_crop": "https://cards.scryfall.io/border_crop/front/5/b/5b08b0a6-c94e-4407-8a24-c8202497b5f2.jpg?1562916460"
        },
        "back": null
      },
      "scryfallId": "5b08b0a6-c94e-4407-8a24-c8202497b5f2",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-ezlgl2vbw",
      "cardNumber": 8,
      "name": "Buried Ruin",
      "type_line": "Land",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/7/a/7ab1a074-9d92-4125-9200-84cd035f8f53.jpg?1752945242",
          "normal": "https://cards.scryfall.io/normal/front/7/a/7ab1a074-9d92-4125-9200-84cd035f8f53.jpg?1752945242",
          "large": "https://cards.scryfall.io/large/front/7/a/7ab1a074-9d92-4125-9200-84cd035f8f53.jpg?1752945242",
          "png": "https://cards.scryfall.io/png/front/7/a/7ab1a074-9d92-4125-9200-84cd035f8f53.png?1752945242",
          "art_crop": "https://cards.scryfall.io/art_crop/front/7/a/7ab1a074-9d92-4125-9200-84cd035f8f53.jpg?1752945242",
          "border_crop": "https://cards.scryfall.io/border_crop/front/7/a/7ab1a074-9d92-4125-9200-84cd035f8f53.jpg?1752945242"
        },
        "back": null
      },
      "scryfallId": "7ab1a074-9d92-4125-9200-84cd035f8f53",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-rt8gcj45d",
      "cardNumber": 9,
      "name": "Cavern of Souls",
      "type_line": "Land",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/3/a/3aad15a2-8a1b-4460-9b06-e85863081878.jpg?1706884128",
          "normal": "https://cards.scryfall.io/normal/front/3/a/3aad15a2-8a1b-4460-9b06-e85863081878.jpg?1706884128",
          "large": "https://cards.scryfall.io/large/front/3/a/3aad15a2-8a1b-4460-9b06-e85863081878.jpg?1706884128",
          "png": "https://cards.scryfall.io/png/front/3/a/3aad15a2-8a1b-4460-9b06-e85863081878.png?1706884128",
          "art_crop": "https://cards.scryfall.io/art_crop/front/3/a/3aad15a2-8a1b-4460-9b06-e85863081878.jpg?1706884128",
          "border_crop": "https://cards.scryfall.io/border_crop/front/3/a/3aad15a2-8a1b-4460-9b06-e85863081878.jpg?1706884128"
        },
        "back": null
      },
      "scryfallId": "3aad15a2-8a1b-4460-9b06-e85863081878",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-2ddk4g228",
      "cardNumber": 10,
      "name": "Command Beacon",
      "type_line": "Land",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/4/3/435e9678-9ff3-4e5d-8061-3f806e1c2ed2.jpg?1743207502",
          "normal": "https://cards.scryfall.io/normal/front/4/3/435e9678-9ff3-4e5d-8061-3f806e1c2ed2.jpg?1743207502",
          "large": "https://cards.scryfall.io/large/front/4/3/435e9678-9ff3-4e5d-8061-3f806e1c2ed2.jpg?1743207502",
          "png": "https://cards.scryfall.io/png/front/4/3/435e9678-9ff3-4e5d-8061-3f806e1c2ed2.png?1743207502",
          "art_crop": "https://cards.scryfall.io/art_crop/front/4/3/435e9678-9ff3-4e5d-8061-3f806e1c2ed2.jpg?1743207502",
          "border_crop": "https://cards.scryfall.io/border_crop/front/4/3/435e9678-9ff3-4e5d-8061-3f806e1c2ed2.jpg?1743207502"
        },
        "back": null
      },
      "scryfallId": "435e9678-9ff3-4e5d-8061-3f806e1c2ed2",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-d4an57ev3",
      "cardNumber": 11,
      "name": "Conspicuous Snoop",
      "type_line": "Creature — Goblin Rogue",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/5/d/5d878dab-5ed2-4ef3-b2c7-472290892854.jpg?1616182104",
          "normal": "https://cards.scryfall.io/normal/front/5/d/5d878dab-5ed2-4ef3-b2c7-472290892854.jpg?1616182104",
          "large": "https://cards.scryfall.io/large/front/5/d/5d878dab-5ed2-4ef3-b2c7-472290892854.jpg?1616182104",
          "png": "https://cards.scryfall.io/png/front/5/d/5d878dab-5ed2-4ef3-b2c7-472290892854.png?1616182104",
          "art_crop": "https://cards.scryfall.io/art_crop/front/5/d/5d878dab-5ed2-4ef3-b2c7-472290892854.jpg?1616182104",
          "border_crop": "https://cards.scryfall.io/border_crop/front/5/d/5d878dab-5ed2-4ef3-b2c7-472290892854.jpg?1616182104"
        },
        "back": null
      },
      "scryfallId": "5d878dab-5ed2-4ef3-b2c7-472290892854",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-6vuwjnx84",
      "cardNumber": 12,
      "name": "Crystal Vein",
      "type_line": "Land",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/1/c/1c28ab69-1a46-45af-a331-1f52f99a9da3.jpg?1592673784",
          "normal": "https://cards.scryfall.io/normal/front/1/c/1c28ab69-1a46-45af-a331-1f52f99a9da3.jpg?1592673784",
          "large": "https://cards.scryfall.io/large/front/1/c/1c28ab69-1a46-45af-a331-1f52f99a9da3.jpg?1592673784",
          "png": "https://cards.scryfall.io/png/front/1/c/1c28ab69-1a46-45af-a331-1f52f99a9da3.png?1592673784",
          "art_crop": "https://cards.scryfall.io/art_crop/front/1/c/1c28ab69-1a46-45af-a331-1f52f99a9da3.jpg?1592673784",
          "border_crop": "https://cards.scryfall.io/border_crop/front/1/c/1c28ab69-1a46-45af-a331-1f52f99a9da3.jpg?1592673784"
        },
        "back": null
      },
      "scryfallId": "1c28ab69-1a46-45af-a331-1f52f99a9da3",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-276pf0nbf",
      "cardNumber": 13,
      "name": "Dark-Dweller Oracle",
      "type_line": "Creature — Goblin Shaman",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/b/d/bd35664f-b99d-46b6-988e-8f2814b0a854.jpg?1673147765",
          "normal": "https://cards.scryfall.io/normal/front/b/d/bd35664f-b99d-46b6-988e-8f2814b0a854.jpg?1673147765",
          "large": "https://cards.scryfall.io/large/front/b/d/bd35664f-b99d-46b6-988e-8f2814b0a854.jpg?1673147765",
          "png": "https://cards.scryfall.io/png/front/b/d/bd35664f-b99d-46b6-988e-8f2814b0a854.png?1673147765",
          "art_crop": "https://cards.scryfall.io/art_crop/front/b/d/bd35664f-b99d-46b6-988e-8f2814b0a854.jpg?1673147765",
          "border_crop": "https://cards.scryfall.io/border_crop/front/b/d/bd35664f-b99d-46b6-988e-8f2814b0a854.jpg?1673147765"
        },
        "back": null
      },
      "scryfallId": "bd35664f-b99d-46b6-988e-8f2814b0a854",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-nkeimxth8",
      "cardNumber": 14,
      "name": "Diamond City",
      "type_line": "Land",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/3/e/3e9bd49a-e9f1-4543-b04a-777a9e5a55ec.jpg?1708742794",
          "normal": "https://cards.scryfall.io/normal/front/3/e/3e9bd49a-e9f1-4543-b04a-777a9e5a55ec.jpg?1708742794",
          "large": "https://cards.scryfall.io/large/front/3/e/3e9bd49a-e9f1-4543-b04a-777a9e5a55ec.jpg?1708742794",
          "png": "https://cards.scryfall.io/png/front/3/e/3e9bd49a-e9f1-4543-b04a-777a9e5a55ec.png?1708742794",
          "art_crop": "https://cards.scryfall.io/art_crop/front/3/e/3e9bd49a-e9f1-4543-b04a-777a9e5a55ec.jpg?1708742794",
          "border_crop": "https://cards.scryfall.io/border_crop/front/3/e/3e9bd49a-e9f1-4543-b04a-777a9e5a55ec.jpg?1708742794"
        },
        "back": null
      },
      "scryfallId": "3e9bd49a-e9f1-4543-b04a-777a9e5a55ec",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-ibts7ja24",
      "cardNumber": 15,
      "name": "Flare of Duplication",
      "type_line": "Instant",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/4/9/497a10c6-131b-464e-95e4-e47708a24d48.jpg?1717470466",
          "normal": "https://cards.scryfall.io/normal/front/4/9/497a10c6-131b-464e-95e4-e47708a24d48.jpg?1717470466",
          "large": "https://cards.scryfall.io/large/front/4/9/497a10c6-131b-464e-95e4-e47708a24d48.jpg?1717470466",
          "png": "https://cards.scryfall.io/png/front/4/9/497a10c6-131b-464e-95e4-e47708a24d48.png?1717470466",
          "art_crop": "https://cards.scryfall.io/art_crop/front/4/9/497a10c6-131b-464e-95e4-e47708a24d48.jpg?1717470466",
          "border_crop": "https://cards.scryfall.io/border_crop/front/4/9/497a10c6-131b-464e-95e4-e47708a24d48.jpg?1717470466"
        },
        "back": null
      },
      "scryfallId": "497a10c6-131b-464e-95e4-e47708a24d48",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-llyf5r5vf",
      "cardNumber": 16,
      "name": "Gamble",
      "type_line": "Sorcery",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/8/e/8e37fae5-ddd0-4e16-8581-71579f89d9c5.jpg?1745319947",
          "normal": "https://cards.scryfall.io/normal/front/8/e/8e37fae5-ddd0-4e16-8581-71579f89d9c5.jpg?1745319947",
          "large": "https://cards.scryfall.io/large/front/8/e/8e37fae5-ddd0-4e16-8581-71579f89d9c5.jpg?1745319947",
          "png": "https://cards.scryfall.io/png/front/8/e/8e37fae5-ddd0-4e16-8581-71579f89d9c5.png?1745319947",
          "art_crop": "https://cards.scryfall.io/art_crop/front/8/e/8e37fae5-ddd0-4e16-8581-71579f89d9c5.jpg?1745319947",
          "border_crop": "https://cards.scryfall.io/border_crop/front/8/e/8e37fae5-ddd0-4e16-8581-71579f89d9c5.jpg?1745319947"
        },
        "back": null
      },
      "scryfallId": "8e37fae5-ddd0-4e16-8581-71579f89d9c5",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-fdcgb4t2q",
      "cardNumber": 17,
      "name": "Gempalm Incinerator",
      "type_line": "Creature — Goblin",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/1/7/17c231e3-10ec-458b-bba1-891812e000f6.jpg?1675199995",
          "normal": "https://cards.scryfall.io/normal/front/1/7/17c231e3-10ec-458b-bba1-891812e000f6.jpg?1675199995",
          "large": "https://cards.scryfall.io/large/front/1/7/17c231e3-10ec-458b-bba1-891812e000f6.jpg?1675199995",
          "png": "https://cards.scryfall.io/png/front/1/7/17c231e3-10ec-458b-bba1-891812e000f6.png?1675199995",
          "art_crop": "https://cards.scryfall.io/art_crop/front/1/7/17c231e3-10ec-458b-bba1-891812e000f6.jpg?1675199995",
          "border_crop": "https://cards.scryfall.io/border_crop/front/1/7/17c231e3-10ec-458b-bba1-891812e000f6.jpg?1675199995"
        },
        "back": null
      },
      "scryfallId": "17c231e3-10ec-458b-bba1-891812e000f6",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-toeb3oxq2",
      "cardNumber": 18,
      "name": "General Kreat, the Boltbringer",
      "type_line": "Legendary Creature — Goblin Soldier",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/2/2/226fc101-abcc-4ed4-8c0b-3677dc8d8f0a.jpg?1730485871",
          "normal": "https://cards.scryfall.io/normal/front/2/2/226fc101-abcc-4ed4-8c0b-3677dc8d8f0a.jpg?1730485871",
          "large": "https://cards.scryfall.io/large/front/2/2/226fc101-abcc-4ed4-8c0b-3677dc8d8f0a.jpg?1730485871",
          "png": "https://cards.scryfall.io/png/front/2/2/226fc101-abcc-4ed4-8c0b-3677dc8d8f0a.png?1730485871",
          "art_crop": "https://cards.scryfall.io/art_crop/front/2/2/226fc101-abcc-4ed4-8c0b-3677dc8d8f0a.jpg?1730485871",
          "border_crop": "https://cards.scryfall.io/border_crop/front/2/2/226fc101-abcc-4ed4-8c0b-3677dc8d8f0a.jpg?1730485871"
        },
        "back": null
      },
      "scryfallId": "226fc101-abcc-4ed4-8c0b-3677dc8d8f0a",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-6otlxi7bk",
      "cardNumber": 19,
      "name": "Goblin Bombardment",
      "type_line": "Enchantment",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/e/2/e262f55e-9239-4a97-a19e-9b08fb34502e.jpg?1626100483",
          "normal": "https://cards.scryfall.io/normal/front/e/2/e262f55e-9239-4a97-a19e-9b08fb34502e.jpg?1626100483",
          "large": "https://cards.scryfall.io/large/front/e/2/e262f55e-9239-4a97-a19e-9b08fb34502e.jpg?1626100483",
          "png": "https://cards.scryfall.io/png/front/e/2/e262f55e-9239-4a97-a19e-9b08fb34502e.png?1626100483",
          "art_crop": "https://cards.scryfall.io/art_crop/front/e/2/e262f55e-9239-4a97-a19e-9b08fb34502e.jpg?1626100483",
          "border_crop": "https://cards.scryfall.io/border_crop/front/e/2/e262f55e-9239-4a97-a19e-9b08fb34502e.jpg?1626100483"
        },
        "back": null
      },
      "scryfallId": "e262f55e-9239-4a97-a19e-9b08fb34502e",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-2dmsv8e64",
      "cardNumber": 20,
      "name": "Goblin Chieftain",
      "type_line": "Creature — Goblin",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/8/9/89fcc35b-76fa-4408-8620-a1e11b2caf1f.jpg?1601077753",
          "normal": "https://cards.scryfall.io/normal/front/8/9/89fcc35b-76fa-4408-8620-a1e11b2caf1f.jpg?1601077753",
          "large": "https://cards.scryfall.io/large/front/8/9/89fcc35b-76fa-4408-8620-a1e11b2caf1f.jpg?1601077753",
          "png": "https://cards.scryfall.io/png/front/8/9/89fcc35b-76fa-4408-8620-a1e11b2caf1f.png?1601077753",
          "art_crop": "https://cards.scryfall.io/art_crop/front/8/9/89fcc35b-76fa-4408-8620-a1e11b2caf1f.jpg?1601077753",
          "border_crop": "https://cards.scryfall.io/border_crop/front/8/9/89fcc35b-76fa-4408-8620-a1e11b2caf1f.jpg?1601077753"
        },
        "back": null
      },
      "scryfallId": "89fcc35b-76fa-4408-8620-a1e11b2caf1f",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-k8eiljrev",
      "cardNumber": 21,
      "name": "Goblin Chirurgeon",
      "type_line": "Creature — Goblin Shaman",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/6/d/6da90318-4db4-4f03-ae2f-b1faeca46f57.jpg?1559592278",
          "normal": "https://cards.scryfall.io/normal/front/6/d/6da90318-4db4-4f03-ae2f-b1faeca46f57.jpg?1559592278",
          "large": "https://cards.scryfall.io/large/front/6/d/6da90318-4db4-4f03-ae2f-b1faeca46f57.jpg?1559592278",
          "png": "https://cards.scryfall.io/png/front/6/d/6da90318-4db4-4f03-ae2f-b1faeca46f57.png?1559592278",
          "art_crop": "https://cards.scryfall.io/art_crop/front/6/d/6da90318-4db4-4f03-ae2f-b1faeca46f57.jpg?1559592278",
          "border_crop": "https://cards.scryfall.io/border_crop/front/6/d/6da90318-4db4-4f03-ae2f-b1faeca46f57.jpg?1559592278"
        },
        "back": null
      },
      "scryfallId": "6da90318-4db4-4f03-ae2f-b1faeca46f57",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-gkvcsifsj",
      "cardNumber": 22,
      "name": "Goblin Cratermaker",
      "type_line": "Creature — Goblin Warrior",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/8/6/86ecaedc-08f1-4de7-aae8-056df57940e0.jpg?1680225520",
          "normal": "https://cards.scryfall.io/normal/front/8/6/86ecaedc-08f1-4de7-aae8-056df57940e0.jpg?1680225520",
          "large": "https://cards.scryfall.io/large/front/8/6/86ecaedc-08f1-4de7-aae8-056df57940e0.jpg?1680225520",
          "png": "https://cards.scryfall.io/png/front/8/6/86ecaedc-08f1-4de7-aae8-056df57940e0.png?1680225520",
          "art_crop": "https://cards.scryfall.io/art_crop/front/8/6/86ecaedc-08f1-4de7-aae8-056df57940e0.jpg?1680225520",
          "border_crop": "https://cards.scryfall.io/border_crop/front/8/6/86ecaedc-08f1-4de7-aae8-056df57940e0.jpg?1680225520"
        },
        "back": null
      },
      "scryfallId": "86ecaedc-08f1-4de7-aae8-056df57940e0",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-985c6qkmd",
      "cardNumber": 23,
      "name": "Goblin Engineer",
      "type_line": "Creature — Goblin Artificer",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/a/5/a55c4d47-5252-40af-961d-c08bc688028a.jpg?1562201855",
          "normal": "https://cards.scryfall.io/normal/front/a/5/a55c4d47-5252-40af-961d-c08bc688028a.jpg?1562201855",
          "large": "https://cards.scryfall.io/large/front/a/5/a55c4d47-5252-40af-961d-c08bc688028a.jpg?1562201855",
          "png": "https://cards.scryfall.io/png/front/a/5/a55c4d47-5252-40af-961d-c08bc688028a.png?1562201855",
          "art_crop": "https://cards.scryfall.io/art_crop/front/a/5/a55c4d47-5252-40af-961d-c08bc688028a.jpg?1562201855",
          "border_crop": "https://cards.scryfall.io/border_crop/front/a/5/a55c4d47-5252-40af-961d-c08bc688028a.jpg?1562201855"
        },
        "back": null
      },
      "scryfallId": "a55c4d47-5252-40af-961d-c08bc688028a",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-o04rw95jy",
      "cardNumber": 24,
      "name": "Goblin Grenade",
      "type_line": "Sorcery",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/b/0/b0e0ef27-3db2-4976-b9db-13e3d7cd795d.jpg?1695355265",
          "normal": "https://cards.scryfall.io/normal/front/b/0/b0e0ef27-3db2-4976-b9db-13e3d7cd795d.jpg?1695355265",
          "large": "https://cards.scryfall.io/large/front/b/0/b0e0ef27-3db2-4976-b9db-13e3d7cd795d.jpg?1695355265",
          "png": "https://cards.scryfall.io/png/front/b/0/b0e0ef27-3db2-4976-b9db-13e3d7cd795d.png?1695355265",
          "art_crop": "https://cards.scryfall.io/art_crop/front/b/0/b0e0ef27-3db2-4976-b9db-13e3d7cd795d.jpg?1695355265",
          "border_crop": "https://cards.scryfall.io/border_crop/front/b/0/b0e0ef27-3db2-4976-b9db-13e3d7cd795d.jpg?1695355265"
        },
        "back": null
      },
      "scryfallId": "b0e0ef27-3db2-4976-b9db-13e3d7cd795d",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-1g0hcwqot",
      "cardNumber": 25,
      "name": "Goblin Matron",
      "type_line": "Creature — Goblin",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/a/5/a521a254-c484-4d59-bb7e-8745e96d4bbf.jpg?1675200004",
          "normal": "https://cards.scryfall.io/normal/front/a/5/a521a254-c484-4d59-bb7e-8745e96d4bbf.jpg?1675200004",
          "large": "https://cards.scryfall.io/large/front/a/5/a521a254-c484-4d59-bb7e-8745e96d4bbf.jpg?1675200004",
          "png": "https://cards.scryfall.io/png/front/a/5/a521a254-c484-4d59-bb7e-8745e96d4bbf.png?1675200004",
          "art_crop": "https://cards.scryfall.io/art_crop/front/a/5/a521a254-c484-4d59-bb7e-8745e96d4bbf.jpg?1675200004",
          "border_crop": "https://cards.scryfall.io/border_crop/front/a/5/a521a254-c484-4d59-bb7e-8745e96d4bbf.jpg?1675200004"
        },
        "back": null
      },
      "scryfallId": "a521a254-c484-4d59-bb7e-8745e96d4bbf",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-k1m1wleqb",
      "cardNumber": 26,
      "name": "Goblin Recruiter",
      "type_line": "Creature — Goblin",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/6/1/61bd1548-2ffa-4705-ba88-913f37d4ce92.jpg?1562818262",
          "normal": "https://cards.scryfall.io/normal/front/6/1/61bd1548-2ffa-4705-ba88-913f37d4ce92.jpg?1562818262",
          "large": "https://cards.scryfall.io/large/front/6/1/61bd1548-2ffa-4705-ba88-913f37d4ce92.jpg?1562818262",
          "png": "https://cards.scryfall.io/png/front/6/1/61bd1548-2ffa-4705-ba88-913f37d4ce92.png?1562818262",
          "art_crop": "https://cards.scryfall.io/art_crop/front/6/1/61bd1548-2ffa-4705-ba88-913f37d4ce92.jpg?1562818262",
          "border_crop": "https://cards.scryfall.io/border_crop/front/6/1/61bd1548-2ffa-4705-ba88-913f37d4ce92.jpg?1562818262"
        },
        "back": null
      },
      "scryfallId": "61bd1548-2ffa-4705-ba88-913f37d4ce92",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-b180k76or",
      "cardNumber": 27,
      "name": "Goblin Sharpshooter",
      "type_line": "Creature — Goblin",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/4/f/4f72e9e2-ed47-40ff-bc2e-8446ef545022.jpg?1562911635",
          "normal": "https://cards.scryfall.io/normal/front/4/f/4f72e9e2-ed47-40ff-bc2e-8446ef545022.jpg?1562911635",
          "large": "https://cards.scryfall.io/large/front/4/f/4f72e9e2-ed47-40ff-bc2e-8446ef545022.jpg?1562911635",
          "png": "https://cards.scryfall.io/png/front/4/f/4f72e9e2-ed47-40ff-bc2e-8446ef545022.png?1562911635",
          "art_crop": "https://cards.scryfall.io/art_crop/front/4/f/4f72e9e2-ed47-40ff-bc2e-8446ef545022.jpg?1562911635",
          "border_crop": "https://cards.scryfall.io/border_crop/front/4/f/4f72e9e2-ed47-40ff-bc2e-8446ef545022.jpg?1562911635"
        },
        "back": null
      },
      "scryfallId": "4f72e9e2-ed47-40ff-bc2e-8446ef545022",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-8cp8vkodw",
      "cardNumber": 28,
      "name": "Goblin War Strike",
      "type_line": "Sorcery",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/d/c/dce59945-37a2-4f09-8831-9d44b4a59ea7.jpg?1562535675",
          "normal": "https://cards.scryfall.io/normal/front/d/c/dce59945-37a2-4f09-8831-9d44b4a59ea7.jpg?1562535675",
          "large": "https://cards.scryfall.io/large/front/d/c/dce59945-37a2-4f09-8831-9d44b4a59ea7.jpg?1562535675",
          "png": "https://cards.scryfall.io/png/front/d/c/dce59945-37a2-4f09-8831-9d44b4a59ea7.png?1562535675",
          "art_crop": "https://cards.scryfall.io/art_crop/front/d/c/dce59945-37a2-4f09-8831-9d44b4a59ea7.jpg?1562535675",
          "border_crop": "https://cards.scryfall.io/border_crop/front/d/c/dce59945-37a2-4f09-8831-9d44b4a59ea7.jpg?1562535675"
        },
        "back": null
      },
      "scryfallId": "dce59945-37a2-4f09-8831-9d44b4a59ea7",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-n8ca7i0ju",
      "cardNumber": 29,
      "name": "Goblin Warchief",
      "type_line": "Creature — Goblin Warrior",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/5/b/5bac033c-dc4e-40a0-b103-4892e4b50249.jpg?1562736294",
          "normal": "https://cards.scryfall.io/normal/front/5/b/5bac033c-dc4e-40a0-b103-4892e4b50249.jpg?1562736294",
          "large": "https://cards.scryfall.io/large/front/5/b/5bac033c-dc4e-40a0-b103-4892e4b50249.jpg?1562736294",
          "png": "https://cards.scryfall.io/png/front/5/b/5bac033c-dc4e-40a0-b103-4892e4b50249.png?1562736294",
          "art_crop": "https://cards.scryfall.io/art_crop/front/5/b/5bac033c-dc4e-40a0-b103-4892e4b50249.jpg?1562736294",
          "border_crop": "https://cards.scryfall.io/border_crop/front/5/b/5bac033c-dc4e-40a0-b103-4892e4b50249.jpg?1562736294"
        },
        "back": null
      },
      "scryfallId": "5bac033c-dc4e-40a0-b103-4892e4b50249",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-68jx3ue9q",
      "cardNumber": 30,
      "name": "Goblin Welder",
      "type_line": "Creature — Goblin Artificer",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/1/7/17cd920a-de09-454a-a9da-c84512e3aff1.jpg?1562272459",
          "normal": "https://cards.scryfall.io/normal/front/1/7/17cd920a-de09-454a-a9da-c84512e3aff1.jpg?1562272459",
          "large": "https://cards.scryfall.io/large/front/1/7/17cd920a-de09-454a-a9da-c84512e3aff1.jpg?1562272459",
          "png": "https://cards.scryfall.io/png/front/1/7/17cd920a-de09-454a-a9da-c84512e3aff1.png?1562272459",
          "art_crop": "https://cards.scryfall.io/art_crop/front/1/7/17cd920a-de09-454a-a9da-c84512e3aff1.jpg?1562272459",
          "border_crop": "https://cards.scryfall.io/border_crop/front/1/7/17cd920a-de09-454a-a9da-c84512e3aff1.jpg?1562272459"
        },
        "back": null
      },
      "scryfallId": "17cd920a-de09-454a-a9da-c84512e3aff1",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-4vtc35hsj",
      "cardNumber": 31,
      "name": "Goro-Goro, Disciple of Ryusei",
      "type_line": "Legendary Creature — Goblin Samurai",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/1/c/1ca736c7-35a9-48c7-b5a9-69b2a6e33ad0.jpg?1654567661",
          "normal": "https://cards.scryfall.io/normal/front/1/c/1ca736c7-35a9-48c7-b5a9-69b2a6e33ad0.jpg?1654567661",
          "large": "https://cards.scryfall.io/large/front/1/c/1ca736c7-35a9-48c7-b5a9-69b2a6e33ad0.jpg?1654567661",
          "png": "https://cards.scryfall.io/png/front/1/c/1ca736c7-35a9-48c7-b5a9-69b2a6e33ad0.png?1654567661",
          "art_crop": "https://cards.scryfall.io/art_crop/front/1/c/1ca736c7-35a9-48c7-b5a9-69b2a6e33ad0.jpg?1654567661",
          "border_crop": "https://cards.scryfall.io/border_crop/front/1/c/1ca736c7-35a9-48c7-b5a9-69b2a6e33ad0.jpg?1654567661"
        },
        "back": null
      },
      "scryfallId": "1ca736c7-35a9-48c7-b5a9-69b2a6e33ad0",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-c9ub2iyt9",
      "cardNumber": 32,
      "name": "Grafdigger's Cage",
      "type_line": "Artifact",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/0/a/0a135e09-b534-4836-9a10-3a9a4a9f8c53.jpg?1592517646",
          "normal": "https://cards.scryfall.io/normal/front/0/a/0a135e09-b534-4836-9a10-3a9a4a9f8c53.jpg?1592517646",
          "large": "https://cards.scryfall.io/large/front/0/a/0a135e09-b534-4836-9a10-3a9a4a9f8c53.jpg?1592517646",
          "png": "https://cards.scryfall.io/png/front/0/a/0a135e09-b534-4836-9a10-3a9a4a9f8c53.png?1592517646",
          "art_crop": "https://cards.scryfall.io/art_crop/front/0/a/0a135e09-b534-4836-9a10-3a9a4a9f8c53.jpg?1592517646",
          "border_crop": "https://cards.scryfall.io/border_crop/front/0/a/0a135e09-b534-4836-9a10-3a9a4a9f8c53.jpg?1592517646"
        },
        "back": null
      },
      "scryfallId": "0a135e09-b534-4836-9a10-3a9a4a9f8c53",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-szissdmk0",
      "cardNumber": 33,
      "name": "Great Furnace",
      "type_line": "Artifact Land",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/7/4/74c5bb44-d72c-4c1a-a38f-86b4a8f49ae1.jpg?1752945336",
          "normal": "https://cards.scryfall.io/normal/front/7/4/74c5bb44-d72c-4c1a-a38f-86b4a8f49ae1.jpg?1752945336",
          "large": "https://cards.scryfall.io/large/front/7/4/74c5bb44-d72c-4c1a-a38f-86b4a8f49ae1.jpg?1752945336",
          "png": "https://cards.scryfall.io/png/front/7/4/74c5bb44-d72c-4c1a-a38f-86b4a8f49ae1.png?1752945336",
          "art_crop": "https://cards.scryfall.io/art_crop/front/7/4/74c5bb44-d72c-4c1a-a38f-86b4a8f49ae1.jpg?1752945336",
          "border_crop": "https://cards.scryfall.io/border_crop/front/7/4/74c5bb44-d72c-4c1a-a38f-86b4a8f49ae1.jpg?1752945336"
        },
        "back": null
      },
      "scryfallId": "74c5bb44-d72c-4c1a-a38f-86b4a8f49ae1",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-9olaopcnn",
      "cardNumber": 34,
      "name": "Grenzo, Havoc Raiser",
      "type_line": "Legendary Creature — Goblin Rogue",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/a/b/aba981f9-ebc6-48ac-b768-557f632b82df.jpg?1743206684",
          "normal": "https://cards.scryfall.io/normal/front/a/b/aba981f9-ebc6-48ac-b768-557f632b82df.jpg?1743206684",
          "large": "https://cards.scryfall.io/large/front/a/b/aba981f9-ebc6-48ac-b768-557f632b82df.jpg?1743206684",
          "png": "https://cards.scryfall.io/png/front/a/b/aba981f9-ebc6-48ac-b768-557f632b82df.png?1743206684",
          "art_crop": "https://cards.scryfall.io/art_crop/front/a/b/aba981f9-ebc6-48ac-b768-557f632b82df.jpg?1743206684",
          "border_crop": "https://cards.scryfall.io/border_crop/front/a/b/aba981f9-ebc6-48ac-b768-557f632b82df.jpg?1743206684"
        },
        "back": null
      },
      "scryfallId": "aba981f9-ebc6-48ac-b768-557f632b82df",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-sxmi34ps8",
      "cardNumber": 35,
      "name": "Howlsquad Heavy",
      "type_line": "Creature — Goblin Mercenary",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/d/f/df582f80-7b9a-4f71-95a9-70548ec7d2d7.jpg?1738989278",
          "normal": "https://cards.scryfall.io/normal/front/d/f/df582f80-7b9a-4f71-95a9-70548ec7d2d7.jpg?1738989278",
          "large": "https://cards.scryfall.io/large/front/d/f/df582f80-7b9a-4f71-95a9-70548ec7d2d7.jpg?1738989278",
          "png": "https://cards.scryfall.io/png/front/d/f/df582f80-7b9a-4f71-95a9-70548ec7d2d7.png?1738989278",
          "art_crop": "https://cards.scryfall.io/art_crop/front/d/f/df582f80-7b9a-4f71-95a9-70548ec7d2d7.jpg?1738989278",
          "border_crop": "https://cards.scryfall.io/border_crop/front/d/f/df582f80-7b9a-4f71-95a9-70548ec7d2d7.jpg?1738989278"
        },
        "back": null
      },
      "scryfallId": "df582f80-7b9a-4f71-95a9-70548ec7d2d7",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-c4x1fj82r",
      "cardNumber": 36,
      "name": "Impact Tremors",
      "type_line": "Enchantment",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/d/0/d0b7cecf-b51b-4d30-b7e9-cd7976271e07.jpg?1730572713",
          "normal": "https://cards.scryfall.io/normal/front/d/0/d0b7cecf-b51b-4d30-b7e9-cd7976271e07.jpg?1730572713",
          "large": "https://cards.scryfall.io/large/front/d/0/d0b7cecf-b51b-4d30-b7e9-cd7976271e07.jpg?1730572713",
          "png": "https://cards.scryfall.io/png/front/d/0/d0b7cecf-b51b-4d30-b7e9-cd7976271e07.png?1730572713",
          "art_crop": "https://cards.scryfall.io/art_crop/front/d/0/d0b7cecf-b51b-4d30-b7e9-cd7976271e07.jpg?1730572713",
          "border_crop": "https://cards.scryfall.io/border_crop/front/d/0/d0b7cecf-b51b-4d30-b7e9-cd7976271e07.jpg?1730572713"
        },
        "back": null
      },
      "scryfallId": "d0b7cecf-b51b-4d30-b7e9-cd7976271e07",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-t6za06cvm",
      "cardNumber": 37,
      "name": "Imperial Recruiter",
      "type_line": "Creature — Human Advisor",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/0/5/05bd329b-5707-42fc-af1c-084cc604e805.jpg?1626100528",
          "normal": "https://cards.scryfall.io/normal/front/0/5/05bd329b-5707-42fc-af1c-084cc604e805.jpg?1626100528",
          "large": "https://cards.scryfall.io/large/front/0/5/05bd329b-5707-42fc-af1c-084cc604e805.jpg?1626100528",
          "png": "https://cards.scryfall.io/png/front/0/5/05bd329b-5707-42fc-af1c-084cc604e805.png?1626100528",
          "art_crop": "https://cards.scryfall.io/art_crop/front/0/5/05bd329b-5707-42fc-af1c-084cc604e805.jpg?1626100528",
          "border_crop": "https://cards.scryfall.io/border_crop/front/0/5/05bd329b-5707-42fc-af1c-084cc604e805.jpg?1626100528"
        },
        "back": null
      },
      "scryfallId": "05bd329b-5707-42fc-af1c-084cc604e805",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-vqldmvl66",
      "cardNumber": 38,
      "name": "Infernal Plunge",
      "type_line": "Sorcery",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/b/3/b3f50e17-c29c-4d2c-b3e7-45d1216b81ea.jpg?1562835822",
          "normal": "https://cards.scryfall.io/normal/front/b/3/b3f50e17-c29c-4d2c-b3e7-45d1216b81ea.jpg?1562835822",
          "large": "https://cards.scryfall.io/large/front/b/3/b3f50e17-c29c-4d2c-b3e7-45d1216b81ea.jpg?1562835822",
          "png": "https://cards.scryfall.io/png/front/b/3/b3f50e17-c29c-4d2c-b3e7-45d1216b81ea.png?1562835822",
          "art_crop": "https://cards.scryfall.io/art_crop/front/b/3/b3f50e17-c29c-4d2c-b3e7-45d1216b81ea.jpg?1562835822",
          "border_crop": "https://cards.scryfall.io/border_crop/front/b/3/b3f50e17-c29c-4d2c-b3e7-45d1216b81ea.jpg?1562835822"
        },
        "back": null
      },
      "scryfallId": "b3f50e17-c29c-4d2c-b3e7-45d1216b81ea",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-ckkze19mv",
      "cardNumber": 39,
      "name": "Inventors' Fair",
      "type_line": "Legendary Land",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/2/7/275471e3-ded1-40ac-91ef-369dce5764d9.jpg?1576383555",
          "normal": "https://cards.scryfall.io/normal/front/2/7/275471e3-ded1-40ac-91ef-369dce5764d9.jpg?1576383555",
          "large": "https://cards.scryfall.io/large/front/2/7/275471e3-ded1-40ac-91ef-369dce5764d9.jpg?1576383555",
          "png": "https://cards.scryfall.io/png/front/2/7/275471e3-ded1-40ac-91ef-369dce5764d9.png?1576383555",
          "art_crop": "https://cards.scryfall.io/art_crop/front/2/7/275471e3-ded1-40ac-91ef-369dce5764d9.jpg?1576383555",
          "border_crop": "https://cards.scryfall.io/border_crop/front/2/7/275471e3-ded1-40ac-91ef-369dce5764d9.jpg?1576383555"
        },
        "back": null
      },
      "scryfallId": "275471e3-ded1-40ac-91ef-369dce5764d9",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-tqglyf64d",
      "cardNumber": 40,
      "name": "Karn, the Great Creator",
      "type_line": "Legendary Planeswalker — Karn",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/d/e/deb3721d-fba1-444f-8b31-1cd10c94c4a0.jpg?1702429246",
          "normal": "https://cards.scryfall.io/normal/front/d/e/deb3721d-fba1-444f-8b31-1cd10c94c4a0.jpg?1702429246",
          "large": "https://cards.scryfall.io/large/front/d/e/deb3721d-fba1-444f-8b31-1cd10c94c4a0.jpg?1702429246",
          "png": "https://cards.scryfall.io/png/front/d/e/deb3721d-fba1-444f-8b31-1cd10c94c4a0.png?1702429246",
          "art_crop": "https://cards.scryfall.io/art_crop/front/d/e/deb3721d-fba1-444f-8b31-1cd10c94c4a0.jpg?1702429246",
          "border_crop": "https://cards.scryfall.io/border_crop/front/d/e/deb3721d-fba1-444f-8b31-1cd10c94c4a0.jpg?1702429246"
        },
        "back": null
      },
      "scryfallId": "deb3721d-fba1-444f-8b31-1cd10c94c4a0",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-o379x54nv",
      "cardNumber": 41,
      "name": "Kiki-Jiki, Mirror Breaker",
      "type_line": "Legendary Creature — Goblin Shaman",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/a/2/a2ff0ee3-9600-4c7d-acec-6ec90595384e.jpg?1562852476",
          "normal": "https://cards.scryfall.io/normal/front/a/2/a2ff0ee3-9600-4c7d-acec-6ec90595384e.jpg?1562852476",
          "large": "https://cards.scryfall.io/large/front/a/2/a2ff0ee3-9600-4c7d-acec-6ec90595384e.jpg?1562852476",
          "png": "https://cards.scryfall.io/png/front/a/2/a2ff0ee3-9600-4c7d-acec-6ec90595384e.png?1562852476",
          "art_crop": "https://cards.scryfall.io/art_crop/front/a/2/a2ff0ee3-9600-4c7d-acec-6ec90595384e.jpg?1562852476",
          "border_crop": "https://cards.scryfall.io/border_crop/front/a/2/a2ff0ee3-9600-4c7d-acec-6ec90595384e.jpg?1562852476"
        },
        "back": null
      },
      "scryfallId": "a2ff0ee3-9600-4c7d-acec-6ec90595384e",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-4vva60u29",
      "cardNumber": 42,
      "name": "Lightning Bolt",
      "type_line": "Instant",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/7/7/77c6fa74-5543-42ac-9ead-0e890b188e99.jpg?1706239968",
          "normal": "https://cards.scryfall.io/normal/front/7/7/77c6fa74-5543-42ac-9ead-0e890b188e99.jpg?1706239968",
          "large": "https://cards.scryfall.io/large/front/7/7/77c6fa74-5543-42ac-9ead-0e890b188e99.jpg?1706239968",
          "png": "https://cards.scryfall.io/png/front/7/7/77c6fa74-5543-42ac-9ead-0e890b188e99.png?1706239968",
          "art_crop": "https://cards.scryfall.io/art_crop/front/7/7/77c6fa74-5543-42ac-9ead-0e890b188e99.jpg?1706239968",
          "border_crop": "https://cards.scryfall.io/border_crop/front/7/7/77c6fa74-5543-42ac-9ead-0e890b188e99.jpg?1706239968"
        },
        "back": null
      },
      "scryfallId": "77c6fa74-5543-42ac-9ead-0e890b188e99",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-hq5rm5dgc",
      "cardNumber": 43,
      "name": "Lightning Greaves",
      "type_line": "Artifact — Equipment",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/8/b/8b59b12c-fde5-4f19-a357-e09f06f490cc.jpg?1743206077",
          "normal": "https://cards.scryfall.io/normal/front/8/b/8b59b12c-fde5-4f19-a357-e09f06f490cc.jpg?1743206077",
          "large": "https://cards.scryfall.io/large/front/8/b/8b59b12c-fde5-4f19-a357-e09f06f490cc.jpg?1743206077",
          "png": "https://cards.scryfall.io/png/front/8/b/8b59b12c-fde5-4f19-a357-e09f06f490cc.png?1743206077",
          "art_crop": "https://cards.scryfall.io/art_crop/front/8/b/8b59b12c-fde5-4f19-a357-e09f06f490cc.jpg?1743206077",
          "border_crop": "https://cards.scryfall.io/border_crop/front/8/b/8b59b12c-fde5-4f19-a357-e09f06f490cc.jpg?1743206077"
        },
        "back": null
      },
      "scryfallId": "8b59b12c-fde5-4f19-a357-e09f06f490cc",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-es1yyesk3",
      "cardNumber": 44,
      "name": "Liquimetal Torque",
      "type_line": "Artifact",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/1/3/13c6101a-da40-4785-8ccb-4e779bbbdb55.jpg?1626099120",
          "normal": "https://cards.scryfall.io/normal/front/1/3/13c6101a-da40-4785-8ccb-4e779bbbdb55.jpg?1626099120",
          "large": "https://cards.scryfall.io/large/front/1/3/13c6101a-da40-4785-8ccb-4e779bbbdb55.jpg?1626099120",
          "png": "https://cards.scryfall.io/png/front/1/3/13c6101a-da40-4785-8ccb-4e779bbbdb55.png?1626099120",
          "art_crop": "https://cards.scryfall.io/art_crop/front/1/3/13c6101a-da40-4785-8ccb-4e779bbbdb55.jpg?1626099120",
          "border_crop": "https://cards.scryfall.io/border_crop/front/1/3/13c6101a-da40-4785-8ccb-4e779bbbdb55.jpg?1626099120"
        },
        "back": null
      },
      "scryfallId": "13c6101a-da40-4785-8ccb-4e779bbbdb55",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-klxtendxa",
      "cardNumber": 45,
      "name": "Lotus Petal",
      "type_line": "Artifact",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/f/8/f85ab5f9-508e-45de-8fa1-ce1f16552ffc.jpg?1701537448",
          "normal": "https://cards.scryfall.io/normal/front/f/8/f85ab5f9-508e-45de-8fa1-ce1f16552ffc.jpg?1701537448",
          "large": "https://cards.scryfall.io/large/front/f/8/f85ab5f9-508e-45de-8fa1-ce1f16552ffc.jpg?1701537448",
          "png": "https://cards.scryfall.io/png/front/f/8/f85ab5f9-508e-45de-8fa1-ce1f16552ffc.png?1701537448",
          "art_crop": "https://cards.scryfall.io/art_crop/front/f/8/f85ab5f9-508e-45de-8fa1-ce1f16552ffc.jpg?1701537448",
          "border_crop": "https://cards.scryfall.io/border_crop/front/f/8/f85ab5f9-508e-45de-8fa1-ce1f16552ffc.jpg?1701537448"
        },
        "back": null
      },
      "scryfallId": "f85ab5f9-508e-45de-8fa1-ce1f16552ffc",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-uln2uuyvy",
      "cardNumber": 46,
      "name": "Magus of the Moon",
      "type_line": "Creature — Human Wizard",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/7/c/7c9bd75c-9606-4607-bfa6-d6acdee12820.jpg?1619397276",
          "normal": "https://cards.scryfall.io/normal/front/7/c/7c9bd75c-9606-4607-bfa6-d6acdee12820.jpg?1619397276",
          "large": "https://cards.scryfall.io/large/front/7/c/7c9bd75c-9606-4607-bfa6-d6acdee12820.jpg?1619397276",
          "png": "https://cards.scryfall.io/png/front/7/c/7c9bd75c-9606-4607-bfa6-d6acdee12820.png?1619397276",
          "art_crop": "https://cards.scryfall.io/art_crop/front/7/c/7c9bd75c-9606-4607-bfa6-d6acdee12820.jpg?1619397276",
          "border_crop": "https://cards.scryfall.io/border_crop/front/7/c/7c9bd75c-9606-4607-bfa6-d6acdee12820.jpg?1619397276"
        },
        "back": null
      },
      "scryfallId": "7c9bd75c-9606-4607-bfa6-d6acdee12820",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-bs0m83nk4",
      "cardNumber": 47,
      "name": "Mana Vault",
      "type_line": "Artifact",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/c/1/c1a31d52-a407-4ded-bfca-cc812f11afa0.jpg?1673149384",
          "normal": "https://cards.scryfall.io/normal/front/c/1/c1a31d52-a407-4ded-bfca-cc812f11afa0.jpg?1673149384",
          "large": "https://cards.scryfall.io/large/front/c/1/c1a31d52-a407-4ded-bfca-cc812f11afa0.jpg?1673149384",
          "png": "https://cards.scryfall.io/png/front/c/1/c1a31d52-a407-4ded-bfca-cc812f11afa0.png?1673149384",
          "art_crop": "https://cards.scryfall.io/art_crop/front/c/1/c1a31d52-a407-4ded-bfca-cc812f11afa0.jpg?1673149384",
          "border_crop": "https://cards.scryfall.io/border_crop/front/c/1/c1a31d52-a407-4ded-bfca-cc812f11afa0.jpg?1673149384"
        },
        "back": null
      },
      "scryfallId": "c1a31d52-a407-4ded-bfca-cc812f11afa0",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-u03k0p9so",
      "cardNumber": 48,
      "name": "Marvin, Murderous Mimic",
      "type_line": "Legendary Artifact Creature — Toy",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/6/6/66898970-b99b-48f2-9240-68c301c95500.jpg?1726286819",
          "normal": "https://cards.scryfall.io/normal/front/6/6/66898970-b99b-48f2-9240-68c301c95500.jpg?1726286819",
          "large": "https://cards.scryfall.io/large/front/6/6/66898970-b99b-48f2-9240-68c301c95500.jpg?1726286819",
          "png": "https://cards.scryfall.io/png/front/6/6/66898970-b99b-48f2-9240-68c301c95500.png?1726286819",
          "art_crop": "https://cards.scryfall.io/art_crop/front/6/6/66898970-b99b-48f2-9240-68c301c95500.jpg?1726286819",
          "border_crop": "https://cards.scryfall.io/border_crop/front/6/6/66898970-b99b-48f2-9240-68c301c95500.jpg?1726286819"
        },
        "back": null
      },
      "scryfallId": "66898970-b99b-48f2-9240-68c301c95500",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-d58dt8x2g",
      "cardNumber": 49,
      "name": "Mass Hysteria",
      "type_line": "Enchantment",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/3/c/3c1854c9-11df-406d-b751-302b6f3a08fd.jpg?1736468190",
          "normal": "https://cards.scryfall.io/normal/front/3/c/3c1854c9-11df-406d-b751-302b6f3a08fd.jpg?1736468190",
          "large": "https://cards.scryfall.io/large/front/3/c/3c1854c9-11df-406d-b751-302b6f3a08fd.jpg?1736468190",
          "png": "https://cards.scryfall.io/png/front/3/c/3c1854c9-11df-406d-b751-302b6f3a08fd.png?1736468190",
          "art_crop": "https://cards.scryfall.io/art_crop/front/3/c/3c1854c9-11df-406d-b751-302b6f3a08fd.jpg?1736468190",
          "border_crop": "https://cards.scryfall.io/border_crop/front/3/c/3c1854c9-11df-406d-b751-302b6f3a08fd.jpg?1736468190"
        },
        "back": null
      },
      "scryfallId": "3c1854c9-11df-406d-b751-302b6f3a08fd",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-3jrbmgwmw",
      "cardNumber": 50,
      "name": "Mob Justice",
      "type_line": "Sorcery",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/b/7/b790d789-bb21-4119-a0e3-43af9bef8acc.jpg?1562597361",
          "normal": "https://cards.scryfall.io/normal/front/b/7/b790d789-bb21-4119-a0e3-43af9bef8acc.jpg?1562597361",
          "large": "https://cards.scryfall.io/large/front/b/7/b790d789-bb21-4119-a0e3-43af9bef8acc.jpg?1562597361",
          "png": "https://cards.scryfall.io/png/front/b/7/b790d789-bb21-4119-a0e3-43af9bef8acc.png?1562597361",
          "art_crop": "https://cards.scryfall.io/art_crop/front/b/7/b790d789-bb21-4119-a0e3-43af9bef8acc.jpg?1562597361",
          "border_crop": "https://cards.scryfall.io/border_crop/front/b/7/b790d789-bb21-4119-a0e3-43af9bef8acc.jpg?1562597361"
        },
        "back": null
      },
      "scryfallId": "b790d789-bb21-4119-a0e3-43af9bef8acc",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-fzhm2xqte",
      "cardNumber": 51,
      "name": "Mogg Fanatic",
      "type_line": "Creature — Goblin",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/d/4/d479ca28-bdc2-4b87-abf7-5aeb229a3f1e.jpg?1580014589",
          "normal": "https://cards.scryfall.io/normal/front/d/4/d479ca28-bdc2-4b87-abf7-5aeb229a3f1e.jpg?1580014589",
          "large": "https://cards.scryfall.io/large/front/d/4/d479ca28-bdc2-4b87-abf7-5aeb229a3f1e.jpg?1580014589",
          "png": "https://cards.scryfall.io/png/front/d/4/d479ca28-bdc2-4b87-abf7-5aeb229a3f1e.png?1580014589",
          "art_crop": "https://cards.scryfall.io/art_crop/front/d/4/d479ca28-bdc2-4b87-abf7-5aeb229a3f1e.jpg?1580014589",
          "border_crop": "https://cards.scryfall.io/border_crop/front/d/4/d479ca28-bdc2-4b87-abf7-5aeb229a3f1e.jpg?1580014589"
        },
        "back": null
      },
      "scryfallId": "d479ca28-bdc2-4b87-abf7-5aeb229a3f1e",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-mdhuzm5yc",
      "cardNumber": 52,
      "name": "Moggcatcher",
      "type_line": "Creature — Human Mercenary",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/9/b/9ba582d7-1dce-4664-8bd9-6b419596788c.jpg?1562631228",
          "normal": "https://cards.scryfall.io/normal/front/9/b/9ba582d7-1dce-4664-8bd9-6b419596788c.jpg?1562631228",
          "large": "https://cards.scryfall.io/large/front/9/b/9ba582d7-1dce-4664-8bd9-6b419596788c.jpg?1562631228",
          "png": "https://cards.scryfall.io/png/front/9/b/9ba582d7-1dce-4664-8bd9-6b419596788c.png?1562631228",
          "art_crop": "https://cards.scryfall.io/art_crop/front/9/b/9ba582d7-1dce-4664-8bd9-6b419596788c.jpg?1562631228",
          "border_crop": "https://cards.scryfall.io/border_crop/front/9/b/9ba582d7-1dce-4664-8bd9-6b419596788c.jpg?1562631228"
        },
        "back": null
      },
      "scryfallId": "9ba582d7-1dce-4664-8bd9-6b419596788c",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-219wd278p",
      "cardNumber": 53,
      "name": "Mountain",
      "type_line": "Basic Land — Mountain",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125",
          "normal": "https://cards.scryfall.io/normal/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125",
          "large": "https://cards.scryfall.io/large/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125",
          "png": "https://cards.scryfall.io/png/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.png?1755290125",
          "art_crop": "https://cards.scryfall.io/art_crop/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125",
          "border_crop": "https://cards.scryfall.io/border_crop/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125"
        },
        "back": null
      },
      "scryfallId": "c44f81ca-f72f-445c-8901-3a894a2a47f9",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-2c722eybg",
      "cardNumber": 54,
      "name": "Mountain",
      "type_line": "Basic Land — Mountain",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125",
          "normal": "https://cards.scryfall.io/normal/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125",
          "large": "https://cards.scryfall.io/large/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125",
          "png": "https://cards.scryfall.io/png/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.png?1755290125",
          "art_crop": "https://cards.scryfall.io/art_crop/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125",
          "border_crop": "https://cards.scryfall.io/border_crop/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125"
        },
        "back": null
      },
      "scryfallId": "c44f81ca-f72f-445c-8901-3a894a2a47f9",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-r5b67xz5c",
      "cardNumber": 55,
      "name": "Mountain",
      "type_line": "Basic Land — Mountain",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125",
          "normal": "https://cards.scryfall.io/normal/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125",
          "large": "https://cards.scryfall.io/large/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125",
          "png": "https://cards.scryfall.io/png/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.png?1755290125",
          "art_crop": "https://cards.scryfall.io/art_crop/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125",
          "border_crop": "https://cards.scryfall.io/border_crop/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125"
        },
        "back": null
      },
      "scryfallId": "c44f81ca-f72f-445c-8901-3a894a2a47f9",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-uw6ikrk3u",
      "cardNumber": 56,
      "name": "Mountain",
      "type_line": "Basic Land — Mountain",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125",
          "normal": "https://cards.scryfall.io/normal/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125",
          "large": "https://cards.scryfall.io/large/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125",
          "png": "https://cards.scryfall.io/png/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.png?1755290125",
          "art_crop": "https://cards.scryfall.io/art_crop/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125",
          "border_crop": "https://cards.scryfall.io/border_crop/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125"
        },
        "back": null
      },
      "scryfallId": "c44f81ca-f72f-445c-8901-3a894a2a47f9",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-qqwd5fdl3",
      "cardNumber": 57,
      "name": "Mountain",
      "type_line": "Basic Land — Mountain",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125",
          "normal": "https://cards.scryfall.io/normal/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125",
          "large": "https://cards.scryfall.io/large/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125",
          "png": "https://cards.scryfall.io/png/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.png?1755290125",
          "art_crop": "https://cards.scryfall.io/art_crop/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125",
          "border_crop": "https://cards.scryfall.io/border_crop/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125"
        },
        "back": null
      },
      "scryfallId": "c44f81ca-f72f-445c-8901-3a894a2a47f9",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-b0o3q5c71",
      "cardNumber": 58,
      "name": "Mountain",
      "type_line": "Basic Land — Mountain",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125",
          "normal": "https://cards.scryfall.io/normal/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125",
          "large": "https://cards.scryfall.io/large/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125",
          "png": "https://cards.scryfall.io/png/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.png?1755290125",
          "art_crop": "https://cards.scryfall.io/art_crop/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125",
          "border_crop": "https://cards.scryfall.io/border_crop/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125"
        },
        "back": null
      },
      "scryfallId": "c44f81ca-f72f-445c-8901-3a894a2a47f9",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-2cyfzdtrv",
      "cardNumber": 59,
      "name": "Mountain",
      "type_line": "Basic Land — Mountain",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125",
          "normal": "https://cards.scryfall.io/normal/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125",
          "large": "https://cards.scryfall.io/large/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125",
          "png": "https://cards.scryfall.io/png/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.png?1755290125",
          "art_crop": "https://cards.scryfall.io/art_crop/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125",
          "border_crop": "https://cards.scryfall.io/border_crop/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125"
        },
        "back": null
      },
      "scryfallId": "c44f81ca-f72f-445c-8901-3a894a2a47f9",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-d3pqu6kld",
      "cardNumber": 60,
      "name": "Mountain",
      "type_line": "Basic Land — Mountain",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125",
          "normal": "https://cards.scryfall.io/normal/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125",
          "large": "https://cards.scryfall.io/large/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125",
          "png": "https://cards.scryfall.io/png/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.png?1755290125",
          "art_crop": "https://cards.scryfall.io/art_crop/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125",
          "border_crop": "https://cards.scryfall.io/border_crop/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125"
        },
        "back": null
      },
      "scryfallId": "c44f81ca-f72f-445c-8901-3a894a2a47f9",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-asb5oqdo7",
      "cardNumber": 61,
      "name": "Mountain",
      "type_line": "Basic Land — Mountain",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125",
          "normal": "https://cards.scryfall.io/normal/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125",
          "large": "https://cards.scryfall.io/large/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125",
          "png": "https://cards.scryfall.io/png/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.png?1755290125",
          "art_crop": "https://cards.scryfall.io/art_crop/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125",
          "border_crop": "https://cards.scryfall.io/border_crop/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125"
        },
        "back": null
      },
      "scryfallId": "c44f81ca-f72f-445c-8901-3a894a2a47f9",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-c1vpco44a",
      "cardNumber": 62,
      "name": "Mountain",
      "type_line": "Basic Land — Mountain",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125",
          "normal": "https://cards.scryfall.io/normal/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125",
          "large": "https://cards.scryfall.io/large/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125",
          "png": "https://cards.scryfall.io/png/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.png?1755290125",
          "art_crop": "https://cards.scryfall.io/art_crop/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125",
          "border_crop": "https://cards.scryfall.io/border_crop/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125"
        },
        "back": null
      },
      "scryfallId": "c44f81ca-f72f-445c-8901-3a894a2a47f9",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-xla6fdh51",
      "cardNumber": 63,
      "name": "Mountain",
      "type_line": "Basic Land — Mountain",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125",
          "normal": "https://cards.scryfall.io/normal/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125",
          "large": "https://cards.scryfall.io/large/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125",
          "png": "https://cards.scryfall.io/png/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.png?1755290125",
          "art_crop": "https://cards.scryfall.io/art_crop/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125",
          "border_crop": "https://cards.scryfall.io/border_crop/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125"
        },
        "back": null
      },
      "scryfallId": "c44f81ca-f72f-445c-8901-3a894a2a47f9",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-12tydyo9w",
      "cardNumber": 64,
      "name": "Mountain",
      "type_line": "Basic Land — Mountain",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125",
          "normal": "https://cards.scryfall.io/normal/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125",
          "large": "https://cards.scryfall.io/large/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125",
          "png": "https://cards.scryfall.io/png/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.png?1755290125",
          "art_crop": "https://cards.scryfall.io/art_crop/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125",
          "border_crop": "https://cards.scryfall.io/border_crop/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125"
        },
        "back": null
      },
      "scryfallId": "c44f81ca-f72f-445c-8901-3a894a2a47f9",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-5wjq5srij",
      "cardNumber": 65,
      "name": "Mountain",
      "type_line": "Basic Land — Mountain",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125",
          "normal": "https://cards.scryfall.io/normal/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125",
          "large": "https://cards.scryfall.io/large/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125",
          "png": "https://cards.scryfall.io/png/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.png?1755290125",
          "art_crop": "https://cards.scryfall.io/art_crop/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125",
          "border_crop": "https://cards.scryfall.io/border_crop/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125"
        },
        "back": null
      },
      "scryfallId": "c44f81ca-f72f-445c-8901-3a894a2a47f9",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-z5zbs80b1",
      "cardNumber": 66,
      "name": "Mountain",
      "type_line": "Basic Land — Mountain",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125",
          "normal": "https://cards.scryfall.io/normal/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125",
          "large": "https://cards.scryfall.io/large/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125",
          "png": "https://cards.scryfall.io/png/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.png?1755290125",
          "art_crop": "https://cards.scryfall.io/art_crop/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125",
          "border_crop": "https://cards.scryfall.io/border_crop/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125"
        },
        "back": null
      },
      "scryfallId": "c44f81ca-f72f-445c-8901-3a894a2a47f9",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-srspc1uhx",
      "cardNumber": 67,
      "name": "Mountain",
      "type_line": "Basic Land — Mountain",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125",
          "normal": "https://cards.scryfall.io/normal/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125",
          "large": "https://cards.scryfall.io/large/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125",
          "png": "https://cards.scryfall.io/png/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.png?1755290125",
          "art_crop": "https://cards.scryfall.io/art_crop/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125",
          "border_crop": "https://cards.scryfall.io/border_crop/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125"
        },
        "back": null
      },
      "scryfallId": "c44f81ca-f72f-445c-8901-3a894a2a47f9",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-ugq355rpr",
      "cardNumber": 68,
      "name": "Mountain",
      "type_line": "Basic Land — Mountain",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125",
          "normal": "https://cards.scryfall.io/normal/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125",
          "large": "https://cards.scryfall.io/large/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125",
          "png": "https://cards.scryfall.io/png/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.png?1755290125",
          "art_crop": "https://cards.scryfall.io/art_crop/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125",
          "border_crop": "https://cards.scryfall.io/border_crop/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125"
        },
        "back": null
      },
      "scryfallId": "c44f81ca-f72f-445c-8901-3a894a2a47f9",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-oxo1mssxu",
      "cardNumber": 69,
      "name": "Mountain",
      "type_line": "Basic Land — Mountain",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125",
          "normal": "https://cards.scryfall.io/normal/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125",
          "large": "https://cards.scryfall.io/large/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125",
          "png": "https://cards.scryfall.io/png/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.png?1755290125",
          "art_crop": "https://cards.scryfall.io/art_crop/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125",
          "border_crop": "https://cards.scryfall.io/border_crop/front/c/4/c44f81ca-f72f-445c-8901-3a894a2a47f9.jpg?1755290125"
        },
        "back": null
      },
      "scryfallId": "c44f81ca-f72f-445c-8901-3a894a2a47f9",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-kj6jwr8y7",
      "cardNumber": 70,
      "name": "Pashalik Mons",
      "type_line": "Legendary Creature — Goblin Warrior",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/c/a/ca20a650-65b0-4714-b7ce-0481af3db377.jpg?1675200126",
          "normal": "https://cards.scryfall.io/normal/front/c/a/ca20a650-65b0-4714-b7ce-0481af3db377.jpg?1675200126",
          "large": "https://cards.scryfall.io/large/front/c/a/ca20a650-65b0-4714-b7ce-0481af3db377.jpg?1675200126",
          "png": "https://cards.scryfall.io/png/front/c/a/ca20a650-65b0-4714-b7ce-0481af3db377.png?1675200126",
          "art_crop": "https://cards.scryfall.io/art_crop/front/c/a/ca20a650-65b0-4714-b7ce-0481af3db377.jpg?1675200126",
          "border_crop": "https://cards.scryfall.io/border_crop/front/c/a/ca20a650-65b0-4714-b7ce-0481af3db377.jpg?1675200126"
        },
        "back": null
      },
      "scryfallId": "ca20a650-65b0-4714-b7ce-0481af3db377",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-9vwvkr3ss",
      "cardNumber": 71,
      "name": "Phyrexian Altar",
      "type_line": "Artifact",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/9/5/95d9f93c-50a8-41a9-be98-d1900bf1c12f.jpg?1673149406",
          "normal": "https://cards.scryfall.io/normal/front/9/5/95d9f93c-50a8-41a9-be98-d1900bf1c12f.jpg?1673149406",
          "large": "https://cards.scryfall.io/large/front/9/5/95d9f93c-50a8-41a9-be98-d1900bf1c12f.jpg?1673149406",
          "png": "https://cards.scryfall.io/png/front/9/5/95d9f93c-50a8-41a9-be98-d1900bf1c12f.png?1673149406",
          "art_crop": "https://cards.scryfall.io/art_crop/front/9/5/95d9f93c-50a8-41a9-be98-d1900bf1c12f.jpg?1673149406",
          "border_crop": "https://cards.scryfall.io/border_crop/front/9/5/95d9f93c-50a8-41a9-be98-d1900bf1c12f.jpg?1673149406"
        },
        "back": null
      },
      "scryfallId": "95d9f93c-50a8-41a9-be98-d1900bf1c12f",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-bgpgmrlf5",
      "cardNumber": 72,
      "name": "Powerbalance",
      "type_line": "Enchantment",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/a/f/aff7c0bb-1210-4aeb-b5f8-1387eb633b0f.jpg?1717012263",
          "normal": "https://cards.scryfall.io/normal/front/a/f/aff7c0bb-1210-4aeb-b5f8-1387eb633b0f.jpg?1717012263",
          "large": "https://cards.scryfall.io/large/front/a/f/aff7c0bb-1210-4aeb-b5f8-1387eb633b0f.jpg?1717012263",
          "png": "https://cards.scryfall.io/png/front/a/f/aff7c0bb-1210-4aeb-b5f8-1387eb633b0f.png?1717012263",
          "art_crop": "https://cards.scryfall.io/art_crop/front/a/f/aff7c0bb-1210-4aeb-b5f8-1387eb633b0f.jpg?1717012263",
          "border_crop": "https://cards.scryfall.io/border_crop/front/a/f/aff7c0bb-1210-4aeb-b5f8-1387eb633b0f.jpg?1717012263"
        },
        "back": null
      },
      "scryfallId": "aff7c0bb-1210-4aeb-b5f8-1387eb633b0f",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-hrmgz7vud",
      "cardNumber": 73,
      "name": "Professional Face-Breaker",
      "type_line": "Creature — Human Warrior",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/4/2/42acbf52-b137-44f0-a815-2817fe8d2da2.jpg?1664411677",
          "normal": "https://cards.scryfall.io/normal/front/4/2/42acbf52-b137-44f0-a815-2817fe8d2da2.jpg?1664411677",
          "large": "https://cards.scryfall.io/large/front/4/2/42acbf52-b137-44f0-a815-2817fe8d2da2.jpg?1664411677",
          "png": "https://cards.scryfall.io/png/front/4/2/42acbf52-b137-44f0-a815-2817fe8d2da2.png?1664411677",
          "art_crop": "https://cards.scryfall.io/art_crop/front/4/2/42acbf52-b137-44f0-a815-2817fe8d2da2.jpg?1664411677",
          "border_crop": "https://cards.scryfall.io/border_crop/front/4/2/42acbf52-b137-44f0-a815-2817fe8d2da2.jpg?1664411677"
        },
        "back": null
      },
      "scryfallId": "42acbf52-b137-44f0-a815-2817fe8d2da2",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-dyjj3kpio",
      "cardNumber": 74,
      "name": "Pyre of Heroes",
      "type_line": "Artifact",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/a/e/ae9a8e44-f5de-497d-be48-adf1bcbaec97.jpg?1631052216",
          "normal": "https://cards.scryfall.io/normal/front/a/e/ae9a8e44-f5de-497d-be48-adf1bcbaec97.jpg?1631052216",
          "large": "https://cards.scryfall.io/large/front/a/e/ae9a8e44-f5de-497d-be48-adf1bcbaec97.jpg?1631052216",
          "png": "https://cards.scryfall.io/png/front/a/e/ae9a8e44-f5de-497d-be48-adf1bcbaec97.png?1631052216",
          "art_crop": "https://cards.scryfall.io/art_crop/front/a/e/ae9a8e44-f5de-497d-be48-adf1bcbaec97.jpg?1631052216",
          "border_crop": "https://cards.scryfall.io/border_crop/front/a/e/ae9a8e44-f5de-497d-be48-adf1bcbaec97.jpg?1631052216"
        },
        "back": null
      },
      "scryfallId": "ae9a8e44-f5de-497d-be48-adf1bcbaec97",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-17aszzb4m",
      "cardNumber": 75,
      "name": "Pyroblast",
      "type_line": "Instant",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/b/0/b029eb9a-dd7a-40c2-96c4-0063d9cc002c.jpg?1580014621",
          "normal": "https://cards.scryfall.io/normal/front/b/0/b029eb9a-dd7a-40c2-96c4-0063d9cc002c.jpg?1580014621",
          "large": "https://cards.scryfall.io/large/front/b/0/b029eb9a-dd7a-40c2-96c4-0063d9cc002c.jpg?1580014621",
          "png": "https://cards.scryfall.io/png/front/b/0/b029eb9a-dd7a-40c2-96c4-0063d9cc002c.png?1580014621",
          "art_crop": "https://cards.scryfall.io/art_crop/front/b/0/b029eb9a-dd7a-40c2-96c4-0063d9cc002c.jpg?1580014621",
          "border_crop": "https://cards.scryfall.io/border_crop/front/b/0/b029eb9a-dd7a-40c2-96c4-0063d9cc002c.jpg?1580014621"
        },
        "back": null
      },
      "scryfallId": "b029eb9a-dd7a-40c2-96c4-0063d9cc002c",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-luclv8yev",
      "cardNumber": 76,
      "name": "Pyrokinesis",
      "type_line": "Instant",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/2/5/25f98f02-9ada-4561-93fd-9cfcb0f48b5d.jpg?1580014628",
          "normal": "https://cards.scryfall.io/normal/front/2/5/25f98f02-9ada-4561-93fd-9cfcb0f48b5d.jpg?1580014628",
          "large": "https://cards.scryfall.io/large/front/2/5/25f98f02-9ada-4561-93fd-9cfcb0f48b5d.jpg?1580014628",
          "png": "https://cards.scryfall.io/png/front/2/5/25f98f02-9ada-4561-93fd-9cfcb0f48b5d.png?1580014628",
          "art_crop": "https://cards.scryfall.io/art_crop/front/2/5/25f98f02-9ada-4561-93fd-9cfcb0f48b5d.jpg?1580014628",
          "border_crop": "https://cards.scryfall.io/border_crop/front/2/5/25f98f02-9ada-4561-93fd-9cfcb0f48b5d.jpg?1580014628"
        },
        "back": null
      },
      "scryfallId": "25f98f02-9ada-4561-93fd-9cfcb0f48b5d",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-kkvx2uutr",
      "cardNumber": 77,
      "name": "Reckless Handling",
      "type_line": "Sorcery",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/2/3/239165bb-7819-4d54-a84c-2911934253d6.jpg?1684340607",
          "normal": "https://cards.scryfall.io/normal/front/2/3/239165bb-7819-4d54-a84c-2911934253d6.jpg?1684340607",
          "large": "https://cards.scryfall.io/large/front/2/3/239165bb-7819-4d54-a84c-2911934253d6.jpg?1684340607",
          "png": "https://cards.scryfall.io/png/front/2/3/239165bb-7819-4d54-a84c-2911934253d6.png?1684340607",
          "art_crop": "https://cards.scryfall.io/art_crop/front/2/3/239165bb-7819-4d54-a84c-2911934253d6.jpg?1684340607",
          "border_crop": "https://cards.scryfall.io/border_crop/front/2/3/239165bb-7819-4d54-a84c-2911934253d6.jpg?1684340607"
        },
        "back": null
      },
      "scryfallId": "239165bb-7819-4d54-a84c-2911934253d6",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-5fo1z1j9b",
      "cardNumber": 78,
      "name": "Red Elemental Blast",
      "type_line": "Instant",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/7/0/70a45e9b-699e-425a-9f3d-267274830d3e.jpg?1562436618",
          "normal": "https://cards.scryfall.io/normal/front/7/0/70a45e9b-699e-425a-9f3d-267274830d3e.jpg?1562436618",
          "large": "https://cards.scryfall.io/large/front/7/0/70a45e9b-699e-425a-9f3d-267274830d3e.jpg?1562436618",
          "png": "https://cards.scryfall.io/png/front/7/0/70a45e9b-699e-425a-9f3d-267274830d3e.png?1562436618",
          "art_crop": "https://cards.scryfall.io/art_crop/front/7/0/70a45e9b-699e-425a-9f3d-267274830d3e.jpg?1562436618",
          "border_crop": "https://cards.scryfall.io/border_crop/front/7/0/70a45e9b-699e-425a-9f3d-267274830d3e.jpg?1562436618"
        },
        "back": null
      },
      "scryfallId": "70a45e9b-699e-425a-9f3d-267274830d3e",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-3ssu5k8pg",
      "cardNumber": 79,
      "name": "Return the Favor",
      "type_line": "Instant",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/a/9/a9cc02d1-799d-42aa-9bc2-4c05452b63b4.jpg?1712860602",
          "normal": "https://cards.scryfall.io/normal/front/a/9/a9cc02d1-799d-42aa-9bc2-4c05452b63b4.jpg?1712860602",
          "large": "https://cards.scryfall.io/large/front/a/9/a9cc02d1-799d-42aa-9bc2-4c05452b63b4.jpg?1712860602",
          "png": "https://cards.scryfall.io/png/front/a/9/a9cc02d1-799d-42aa-9bc2-4c05452b63b4.png?1712860602",
          "art_crop": "https://cards.scryfall.io/art_crop/front/a/9/a9cc02d1-799d-42aa-9bc2-4c05452b63b4.jpg?1712860602",
          "border_crop": "https://cards.scryfall.io/border_crop/front/a/9/a9cc02d1-799d-42aa-9bc2-4c05452b63b4.jpg?1712860602"
        },
        "back": null
      },
      "scryfallId": "a9cc02d1-799d-42aa-9bc2-4c05452b63b4",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-3idq30zng",
      "cardNumber": 80,
      "name": "Reverberate",
      "type_line": "Instant",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/5/9/5996feb4-02ac-45e8-a7f2-966cf74391dc.jpg?1562554142",
          "normal": "https://cards.scryfall.io/normal/front/5/9/5996feb4-02ac-45e8-a7f2-966cf74391dc.jpg?1562554142",
          "large": "https://cards.scryfall.io/large/front/5/9/5996feb4-02ac-45e8-a7f2-966cf74391dc.jpg?1562554142",
          "png": "https://cards.scryfall.io/png/front/5/9/5996feb4-02ac-45e8-a7f2-966cf74391dc.png?1562554142",
          "art_crop": "https://cards.scryfall.io/art_crop/front/5/9/5996feb4-02ac-45e8-a7f2-966cf74391dc.jpg?1562554142",
          "border_crop": "https://cards.scryfall.io/border_crop/front/5/9/5996feb4-02ac-45e8-a7f2-966cf74391dc.jpg?1562554142"
        },
        "back": null
      },
      "scryfallId": "5996feb4-02ac-45e8-a7f2-966cf74391dc",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-b2lznq387",
      "cardNumber": 81,
      "name": "Ruby Medallion",
      "type_line": "Artifact",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/6/3/630febf5-58ff-4dab-a5a8-575ebc5435a6.jpg?1717013787",
          "normal": "https://cards.scryfall.io/normal/front/6/3/630febf5-58ff-4dab-a5a8-575ebc5435a6.jpg?1717013787",
          "large": "https://cards.scryfall.io/large/front/6/3/630febf5-58ff-4dab-a5a8-575ebc5435a6.jpg?1717013787",
          "png": "https://cards.scryfall.io/png/front/6/3/630febf5-58ff-4dab-a5a8-575ebc5435a6.png?1717013787",
          "art_crop": "https://cards.scryfall.io/art_crop/front/6/3/630febf5-58ff-4dab-a5a8-575ebc5435a6.jpg?1717013787",
          "border_crop": "https://cards.scryfall.io/border_crop/front/6/3/630febf5-58ff-4dab-a5a8-575ebc5435a6.jpg?1717013787"
        },
        "back": null
      },
      "scryfallId": "630febf5-58ff-4dab-a5a8-575ebc5435a6",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-zhqozk8cz",
      "cardNumber": 82,
      "name": "Shatterskull Smashing // Shatterskull, the Hammer Pass",
      "type_line": "Sorcery // Land",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/b/c/bc7239ea-f8aa-4a6f-87bd-c35359635673.jpg?1604197844",
          "normal": "https://cards.scryfall.io/normal/front/b/c/bc7239ea-f8aa-4a6f-87bd-c35359635673.jpg?1604197844",
          "large": "https://cards.scryfall.io/large/front/b/c/bc7239ea-f8aa-4a6f-87bd-c35359635673.jpg?1604197844",
          "png": "https://cards.scryfall.io/png/front/b/c/bc7239ea-f8aa-4a6f-87bd-c35359635673.png?1604197844",
          "art_crop": "https://cards.scryfall.io/art_crop/front/b/c/bc7239ea-f8aa-4a6f-87bd-c35359635673.jpg?1604197844",
          "border_crop": "https://cards.scryfall.io/border_crop/front/b/c/bc7239ea-f8aa-4a6f-87bd-c35359635673.jpg?1604197844"
        },
        "back": {
          "small": "https://cards.scryfall.io/small/back/b/c/bc7239ea-f8aa-4a6f-87bd-c35359635673.jpg?1604197844",
          "normal": "https://cards.scryfall.io/normal/back/b/c/bc7239ea-f8aa-4a6f-87bd-c35359635673.jpg?1604197844",
          "large": "https://cards.scryfall.io/large/back/b/c/bc7239ea-f8aa-4a6f-87bd-c35359635673.jpg?1604197844",
          "png": "https://cards.scryfall.io/png/back/b/c/bc7239ea-f8aa-4a6f-87bd-c35359635673.png?1604197844",
          "art_crop": "https://cards.scryfall.io/art_crop/back/b/c/bc7239ea-f8aa-4a6f-87bd-c35359635673.jpg?1604197844",
          "border_crop": "https://cards.scryfall.io/border_crop/back/b/c/bc7239ea-f8aa-4a6f-87bd-c35359635673.jpg?1604197844"
        }
      },
      "scryfallId": "bc7239ea-f8aa-4a6f-87bd-c35359635673",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-gg361w25z",
      "cardNumber": 83,
      "name": "Simian Spirit Guide",
      "type_line": "Creature — Ape Spirit",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/0/e/0e57335d-4066-4d73-83cd-67a215e01a4e.jpg?1619397622",
          "normal": "https://cards.scryfall.io/normal/front/0/e/0e57335d-4066-4d73-83cd-67a215e01a4e.jpg?1619397622",
          "large": "https://cards.scryfall.io/large/front/0/e/0e57335d-4066-4d73-83cd-67a215e01a4e.jpg?1619397622",
          "png": "https://cards.scryfall.io/png/front/0/e/0e57335d-4066-4d73-83cd-67a215e01a4e.png?1619397622",
          "art_crop": "https://cards.scryfall.io/art_crop/front/0/e/0e57335d-4066-4d73-83cd-67a215e01a4e.jpg?1619397622",
          "border_crop": "https://cards.scryfall.io/border_crop/front/0/e/0e57335d-4066-4d73-83cd-67a215e01a4e.jpg?1619397622"
        },
        "back": null
      },
      "scryfallId": "0e57335d-4066-4d73-83cd-67a215e01a4e",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-ua72166h1",
      "cardNumber": 84,
      "name": "Skirk Prospector",
      "type_line": "Creature — Goblin",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/7/b/7bc508b3-8b38-4cf0-89a7-a2cb247ed083.jpg?1675200167",
          "normal": "https://cards.scryfall.io/normal/front/7/b/7bc508b3-8b38-4cf0-89a7-a2cb247ed083.jpg?1675200167",
          "large": "https://cards.scryfall.io/large/front/7/b/7bc508b3-8b38-4cf0-89a7-a2cb247ed083.jpg?1675200167",
          "png": "https://cards.scryfall.io/png/front/7/b/7bc508b3-8b38-4cf0-89a7-a2cb247ed083.png?1675200167",
          "art_crop": "https://cards.scryfall.io/art_crop/front/7/b/7bc508b3-8b38-4cf0-89a7-a2cb247ed083.jpg?1675200167",
          "border_crop": "https://cards.scryfall.io/border_crop/front/7/b/7bc508b3-8b38-4cf0-89a7-a2cb247ed083.jpg?1675200167"
        },
        "back": null
      },
      "scryfallId": "7bc508b3-8b38-4cf0-89a7-a2cb247ed083",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-j4724bnxy",
      "cardNumber": 85,
      "name": "Skullclamp",
      "type_line": "Artifact — Equipment",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/b/5/b5bb89dd-9d31-49d9-ba54-4a04798e515e.jpg?1743206083",
          "normal": "https://cards.scryfall.io/normal/front/b/5/b5bb89dd-9d31-49d9-ba54-4a04798e515e.jpg?1743206083",
          "large": "https://cards.scryfall.io/large/front/b/5/b5bb89dd-9d31-49d9-ba54-4a04798e515e.jpg?1743206083",
          "png": "https://cards.scryfall.io/png/front/b/5/b5bb89dd-9d31-49d9-ba54-4a04798e515e.png?1743206083",
          "art_crop": "https://cards.scryfall.io/art_crop/front/b/5/b5bb89dd-9d31-49d9-ba54-4a04798e515e.jpg?1743206083",
          "border_crop": "https://cards.scryfall.io/border_crop/front/b/5/b5bb89dd-9d31-49d9-ba54-4a04798e515e.jpg?1743206083"
        },
        "back": null
      },
      "scryfallId": "b5bb89dd-9d31-49d9-ba54-4a04798e515e",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-xbwljr19l",
      "cardNumber": 86,
      "name": "Sokenzan, Crucible of Defiance",
      "type_line": "Legendary Land",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/a/a/aa548dcd-c1dd-492d-a69f-c65dfeef0633.jpg?1654569016",
          "normal": "https://cards.scryfall.io/normal/front/a/a/aa548dcd-c1dd-492d-a69f-c65dfeef0633.jpg?1654569016",
          "large": "https://cards.scryfall.io/large/front/a/a/aa548dcd-c1dd-492d-a69f-c65dfeef0633.jpg?1654569016",
          "png": "https://cards.scryfall.io/png/front/a/a/aa548dcd-c1dd-492d-a69f-c65dfeef0633.png?1654569016",
          "art_crop": "https://cards.scryfall.io/art_crop/front/a/a/aa548dcd-c1dd-492d-a69f-c65dfeef0633.jpg?1654569016",
          "border_crop": "https://cards.scryfall.io/border_crop/front/a/a/aa548dcd-c1dd-492d-a69f-c65dfeef0633.jpg?1654569016"
        },
        "back": null
      },
      "scryfallId": "aa548dcd-c1dd-492d-a69f-c65dfeef0633",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-3hoyg7cjs",
      "cardNumber": 87,
      "name": "Sol Ring",
      "type_line": "Artifact",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/e/e/ee6e5a35-fe21-4dee-b0ef-a8f2841511ad.jpg?1752944480",
          "normal": "https://cards.scryfall.io/normal/front/e/e/ee6e5a35-fe21-4dee-b0ef-a8f2841511ad.jpg?1752944480",
          "large": "https://cards.scryfall.io/large/front/e/e/ee6e5a35-fe21-4dee-b0ef-a8f2841511ad.jpg?1752944480",
          "png": "https://cards.scryfall.io/png/front/e/e/ee6e5a35-fe21-4dee-b0ef-a8f2841511ad.png?1752944480",
          "art_crop": "https://cards.scryfall.io/art_crop/front/e/e/ee6e5a35-fe21-4dee-b0ef-a8f2841511ad.jpg?1752944480",
          "border_crop": "https://cards.scryfall.io/border_crop/front/e/e/ee6e5a35-fe21-4dee-b0ef-a8f2841511ad.jpg?1752944480"
        },
        "back": null
      },
      "scryfallId": "ee6e5a35-fe21-4dee-b0ef-a8f2841511ad",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-cu5gf81u7",
      "cardNumber": 88,
      "name": "Soulless Jailer",
      "type_line": "Artifact Creature — Phyrexian Golem",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/b/f/bf9991fd-ea6a-4ed7-b5f1-46a95f8d0634.jpg?1675957252",
          "normal": "https://cards.scryfall.io/normal/front/b/f/bf9991fd-ea6a-4ed7-b5f1-46a95f8d0634.jpg?1675957252",
          "large": "https://cards.scryfall.io/large/front/b/f/bf9991fd-ea6a-4ed7-b5f1-46a95f8d0634.jpg?1675957252",
          "png": "https://cards.scryfall.io/png/front/b/f/bf9991fd-ea6a-4ed7-b5f1-46a95f8d0634.png?1675957252",
          "art_crop": "https://cards.scryfall.io/art_crop/front/b/f/bf9991fd-ea6a-4ed7-b5f1-46a95f8d0634.jpg?1675957252",
          "border_crop": "https://cards.scryfall.io/border_crop/front/b/f/bf9991fd-ea6a-4ed7-b5f1-46a95f8d0634.jpg?1675957252"
        },
        "back": null
      },
      "scryfallId": "bf9991fd-ea6a-4ed7-b5f1-46a95f8d0634",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-fsd4fbg4v",
      "cardNumber": 89,
      "name": "Springleaf Drum",
      "type_line": "Artifact",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/f/3/f3b3869b-6da1-4b01-a2e7-2018d478b6e5.jpg?1599709959",
          "normal": "https://cards.scryfall.io/normal/front/f/3/f3b3869b-6da1-4b01-a2e7-2018d478b6e5.jpg?1599709959",
          "large": "https://cards.scryfall.io/large/front/f/3/f3b3869b-6da1-4b01-a2e7-2018d478b6e5.jpg?1599709959",
          "png": "https://cards.scryfall.io/png/front/f/3/f3b3869b-6da1-4b01-a2e7-2018d478b6e5.png?1599709959",
          "art_crop": "https://cards.scryfall.io/art_crop/front/f/3/f3b3869b-6da1-4b01-a2e7-2018d478b6e5.jpg?1599709959",
          "border_crop": "https://cards.scryfall.io/border_crop/front/f/3/f3b3869b-6da1-4b01-a2e7-2018d478b6e5.jpg?1599709959"
        },
        "back": null
      },
      "scryfallId": "f3b3869b-6da1-4b01-a2e7-2018d478b6e5",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-9n9tesj60",
      "cardNumber": 90,
      "name": "Staff of Domination",
      "type_line": "Artifact",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/f/d/fde838c8-2f32-4e7d-a236-0bc42dd7abd9.jpg?1608911729",
          "normal": "https://cards.scryfall.io/normal/front/f/d/fde838c8-2f32-4e7d-a236-0bc42dd7abd9.jpg?1608911729",
          "large": "https://cards.scryfall.io/large/front/f/d/fde838c8-2f32-4e7d-a236-0bc42dd7abd9.jpg?1608911729",
          "png": "https://cards.scryfall.io/png/front/f/d/fde838c8-2f32-4e7d-a236-0bc42dd7abd9.png?1608911729",
          "art_crop": "https://cards.scryfall.io/art_crop/front/f/d/fde838c8-2f32-4e7d-a236-0bc42dd7abd9.jpg?1608911729",
          "border_crop": "https://cards.scryfall.io/border_crop/front/f/d/fde838c8-2f32-4e7d-a236-0bc42dd7abd9.jpg?1608911729"
        },
        "back": null
      },
      "scryfallId": "fde838c8-2f32-4e7d-a236-0bc42dd7abd9",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-hicp9apz8",
      "cardNumber": 91,
      "name": "Tangle Wire",
      "type_line": "Artifact",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/a/d/ad62f313-8a8a-4ffa-ada2-b12b76288729.jpg?1562631474",
          "normal": "https://cards.scryfall.io/normal/front/a/d/ad62f313-8a8a-4ffa-ada2-b12b76288729.jpg?1562631474",
          "large": "https://cards.scryfall.io/large/front/a/d/ad62f313-8a8a-4ffa-ada2-b12b76288729.jpg?1562631474",
          "png": "https://cards.scryfall.io/png/front/a/d/ad62f313-8a8a-4ffa-ada2-b12b76288729.png?1562631474",
          "art_crop": "https://cards.scryfall.io/art_crop/front/a/d/ad62f313-8a8a-4ffa-ada2-b12b76288729.jpg?1562631474",
          "border_crop": "https://cards.scryfall.io/border_crop/front/a/d/ad62f313-8a8a-4ffa-ada2-b12b76288729.jpg?1562631474"
        },
        "back": null
      },
      "scryfallId": "ad62f313-8a8a-4ffa-ada2-b12b76288729",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-90gwdqdxn",
      "cardNumber": 92,
      "name": "The One Ring",
      "type_line": "Legendary Artifact",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/d/5/d5806e68-1054-458e-866d-1f2470f682b2.jpg?1734350327",
          "normal": "https://cards.scryfall.io/normal/front/d/5/d5806e68-1054-458e-866d-1f2470f682b2.jpg?1734350327",
          "large": "https://cards.scryfall.io/large/front/d/5/d5806e68-1054-458e-866d-1f2470f682b2.jpg?1734350327",
          "png": "https://cards.scryfall.io/png/front/d/5/d5806e68-1054-458e-866d-1f2470f682b2.png?1734350327",
          "art_crop": "https://cards.scryfall.io/art_crop/front/d/5/d5806e68-1054-458e-866d-1f2470f682b2.jpg?1734350327",
          "border_crop": "https://cards.scryfall.io/border_crop/front/d/5/d5806e68-1054-458e-866d-1f2470f682b2.jpg?1734350327"
        },
        "back": null
      },
      "scryfallId": "d5806e68-1054-458e-866d-1f2470f682b2",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-ufrbtfiu9",
      "cardNumber": 93,
      "name": "Thornbite Staff",
      "type_line": "Kindred Artifact — Shaman Equipment",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/c/1/c1ab3225-64a9-411e-b22b-1869e958b8e5.jpg?1562881171",
          "normal": "https://cards.scryfall.io/normal/front/c/1/c1ab3225-64a9-411e-b22b-1869e958b8e5.jpg?1562881171",
          "large": "https://cards.scryfall.io/large/front/c/1/c1ab3225-64a9-411e-b22b-1869e958b8e5.jpg?1562881171",
          "png": "https://cards.scryfall.io/png/front/c/1/c1ab3225-64a9-411e-b22b-1869e958b8e5.png?1562881171",
          "art_crop": "https://cards.scryfall.io/art_crop/front/c/1/c1ab3225-64a9-411e-b22b-1869e958b8e5.jpg?1562881171",
          "border_crop": "https://cards.scryfall.io/border_crop/front/c/1/c1ab3225-64a9-411e-b22b-1869e958b8e5.jpg?1562881171"
        },
        "back": null
      },
      "scryfallId": "c1ab3225-64a9-411e-b22b-1869e958b8e5",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-4fgz7cpa1",
      "cardNumber": 94,
      "name": "Three Tree City",
      "type_line": "Legendary Land",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/5/6/56f88a48-cced-4a9d-8c19-e4f105f0d8a2.jpg?1721427358",
          "normal": "https://cards.scryfall.io/normal/front/5/6/56f88a48-cced-4a9d-8c19-e4f105f0d8a2.jpg?1721427358",
          "large": "https://cards.scryfall.io/large/front/5/6/56f88a48-cced-4a9d-8c19-e4f105f0d8a2.jpg?1721427358",
          "png": "https://cards.scryfall.io/png/front/5/6/56f88a48-cced-4a9d-8c19-e4f105f0d8a2.png?1721427358",
          "art_crop": "https://cards.scryfall.io/art_crop/front/5/6/56f88a48-cced-4a9d-8c19-e4f105f0d8a2.jpg?1721427358",
          "border_crop": "https://cards.scryfall.io/border_crop/front/5/6/56f88a48-cced-4a9d-8c19-e4f105f0d8a2.jpg?1721427358"
        },
        "back": null
      },
      "scryfallId": "56f88a48-cced-4a9d-8c19-e4f105f0d8a2",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-uuommt0os",
      "cardNumber": 95,
      "name": "Torch Courier",
      "type_line": "Creature — Goblin",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/d/4/d4c9fc8c-e68f-4636-84b8-877f6ec04b09.jpg?1572893280",
          "normal": "https://cards.scryfall.io/normal/front/d/4/d4c9fc8c-e68f-4636-84b8-877f6ec04b09.jpg?1572893280",
          "large": "https://cards.scryfall.io/large/front/d/4/d4c9fc8c-e68f-4636-84b8-877f6ec04b09.jpg?1572893280",
          "png": "https://cards.scryfall.io/png/front/d/4/d4c9fc8c-e68f-4636-84b8-877f6ec04b09.png?1572893280",
          "art_crop": "https://cards.scryfall.io/art_crop/front/d/4/d4c9fc8c-e68f-4636-84b8-877f6ec04b09.jpg?1572893280",
          "border_crop": "https://cards.scryfall.io/border_crop/front/d/4/d4c9fc8c-e68f-4636-84b8-877f6ec04b09.jpg?1572893280"
        },
        "back": null
      },
      "scryfallId": "d4c9fc8c-e68f-4636-84b8-877f6ec04b09",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-jfh2dhyew",
      "cardNumber": 96,
      "name": "Umbral Mantle",
      "type_line": "Artifact — Equipment",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/1/0/10e35711-aec9-4024-a2a6-9efff8c71df2.jpg?1562826882",
          "normal": "https://cards.scryfall.io/normal/front/1/0/10e35711-aec9-4024-a2a6-9efff8c71df2.jpg?1562826882",
          "large": "https://cards.scryfall.io/large/front/1/0/10e35711-aec9-4024-a2a6-9efff8c71df2.jpg?1562826882",
          "png": "https://cards.scryfall.io/png/front/1/0/10e35711-aec9-4024-a2a6-9efff8c71df2.png?1562826882",
          "art_crop": "https://cards.scryfall.io/art_crop/front/1/0/10e35711-aec9-4024-a2a6-9efff8c71df2.jpg?1562826882",
          "border_crop": "https://cards.scryfall.io/border_crop/front/1/0/10e35711-aec9-4024-a2a6-9efff8c71df2.jpg?1562826882"
        },
        "back": null
      },
      "scryfallId": "10e35711-aec9-4024-a2a6-9efff8c71df2",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-nizz4ljex",
      "cardNumber": 97,
      "name": "Untimely Malfunction",
      "type_line": "Instant",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/8/5/857bfb0e-17dc-4dda-bc37-3df927a9eae6.jpg?1726286456",
          "normal": "https://cards.scryfall.io/normal/front/8/5/857bfb0e-17dc-4dda-bc37-3df927a9eae6.jpg?1726286456",
          "large": "https://cards.scryfall.io/large/front/8/5/857bfb0e-17dc-4dda-bc37-3df927a9eae6.jpg?1726286456",
          "png": "https://cards.scryfall.io/png/front/8/5/857bfb0e-17dc-4dda-bc37-3df927a9eae6.png?1726286456",
          "art_crop": "https://cards.scryfall.io/art_crop/front/8/5/857bfb0e-17dc-4dda-bc37-3df927a9eae6.jpg?1726286456",
          "border_crop": "https://cards.scryfall.io/border_crop/front/8/5/857bfb0e-17dc-4dda-bc37-3df927a9eae6.jpg?1726286456"
        },
        "back": null
      },
      "scryfallId": "857bfb0e-17dc-4dda-bc37-3df927a9eae6",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-r7bcn6ioo",
      "cardNumber": 98,
      "name": "War Room",
      "type_line": "Land",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/a/8/a824d5c0-cdd3-42e2-ac04-b8cada566163.jpg?1706241294",
          "normal": "https://cards.scryfall.io/normal/front/a/8/a824d5c0-cdd3-42e2-ac04-b8cada566163.jpg?1706241294",
          "large": "https://cards.scryfall.io/large/front/a/8/a824d5c0-cdd3-42e2-ac04-b8cada566163.jpg?1706241294",
          "png": "https://cards.scryfall.io/png/front/a/8/a824d5c0-cdd3-42e2-ac04-b8cada566163.png?1706241294",
          "art_crop": "https://cards.scryfall.io/art_crop/front/a/8/a824d5c0-cdd3-42e2-ac04-b8cada566163.jpg?1706241294",
          "border_crop": "https://cards.scryfall.io/border_crop/front/a/8/a824d5c0-cdd3-42e2-ac04-b8cada566163.jpg?1706241294"
        },
        "back": null
      },
      "scryfallId": "a824d5c0-cdd3-42e2-ac04-b8cada566163",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-ocjdgdlt6",
      "cardNumber": 99,
      "name": "Wild Magic Surge",
      "type_line": "Instant",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/c/4/c4c89d88-9d40-46b6-bee0-6bc2e2ca8ba1.jpg?1674136859",
          "normal": "https://cards.scryfall.io/normal/front/c/4/c4c89d88-9d40-46b6-bee0-6bc2e2ca8ba1.jpg?1674136859",
          "large": "https://cards.scryfall.io/large/front/c/4/c4c89d88-9d40-46b6-bee0-6bc2e2ca8ba1.jpg?1674136859",
          "png": "https://cards.scryfall.io/png/front/c/4/c4c89d88-9d40-46b6-bee0-6bc2e2ca8ba1.png?1674136859",
          "art_crop": "https://cards.scryfall.io/art_crop/front/c/4/c4c89d88-9d40-46b6-bee0-6bc2e2ca8ba1.jpg?1674136859",
          "border_crop": "https://cards.scryfall.io/border_crop/front/c/4/c4c89d88-9d40-46b6-bee0-6bc2e2ca8ba1.jpg?1674136859"
        },
        "back": null
      },
      "scryfallId": "c4c89d88-9d40-46b6-bee0-6bc2e2ca8ba1",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    },
    {
      "id": "card-olxm0e4sh",
      "cardNumber": 100,
      "name": "Krenko, Mob Boss",
      "commander": true,
      "type_line": "Legendary Creature — Goblin Warrior",
      "images": {
        "front": {
          "small": "https://cards.scryfall.io/small/front/8/2/824b2d73-2151-4e5e-9f05-8f63e2bdcaa9.jpg?1730632010",
          "normal": "https://cards.scryfall.io/normal/front/8/2/824b2d73-2151-4e5e-9f05-8f63e2bdcaa9.jpg?1730632010",
          "large": "https://cards.scryfall.io/large/front/8/2/824b2d73-2151-4e5e-9f05-8f63e2bdcaa9.jpg?1730632010",
          "png": "https://cards.scryfall.io/png/front/8/2/824b2d73-2151-4e5e-9f05-8f63e2bdcaa9.png?1730632010",
          "art_crop": "https://cards.scryfall.io/art_crop/front/8/2/824b2d73-2151-4e5e-9f05-8f63e2bdcaa9.jpg?1730632010",
          "border_crop": "https://cards.scryfall.io/border_crop/front/8/2/824b2d73-2151-4e5e-9f05-8f63e2bdcaa9.jpg?1730632010"
        },
        "back": null
      },
      "scryfallId": "824b2d73-2151-4e5e-9f05-8f63e2bdcaa9",
      "x": 100,
      "y": 100,
      "rotation": 0,
      "isTapped": false,
      "isFlipped": false,
      "counters": []
    }
  ]
}